"use client";
import { a as rem, i as _responsive, n as _getArrayProp, r as _getResponsiveSpace, s as EMPTY_RECORD, t as _fillCSSObject } from "./helpers-bwfx1e-Y.js";
import { a as textInputRootStyle, c as useCustomValidity, d as focusFirstDescendant, f as focusLastDescendant, h as _raf2, i as textInputRepresentationStyle, l as _hasFocus, m as _raf, n as textInputBaseStyle, o as responsiveInputPaddingIconRightStyle, p as isFocusable, r as textInputFontSizeStyle, s as responsiveInputPaddingStyle, t as TextInput, u as attemptFocus } from "./textInput-VH0sQqrm.js";
import { a as isHTMLElement, c as isHTMLTextAreaElement, i as isHTMLButtonElement, n as containsOrEqualsElement, o as isHTMLInputElement, r as isHTMLAnchorElement, s as isHTMLSelectElement, t as _isEnterToClickElement } from "./element-BYgCE_iK.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { _ as useTheme_v2, a as useMatchMedia, b as responsivePaddingStyle, c as ThemeColorProvider, d as createGlobalScopedContext, g as useTheme, h as _cardColorStyle, i as usePrefersReducedMotion, l as useRootTheme, m as focusRingStyle, n as LayerProvider, o as useMediaIndex, p as focusRingBorderStyle, s as Card, t as useLayer, u as ThemeProvider, v as responsiveRadiusStyle, y as Box } from "./useLayer-BAVfmbNN.js";
import { t as Flex } from "./flex-C-5JHi1C.js";
import { a as responsiveTextAlignStyle, i as responsiveTextFont, n as Text, r as SpanWithTextOverflow, t as Stack } from "./stack-C2HKTF-l.js";
import { t as responsiveFont } from "./responsiveFont-hN1mZFjm.js";
import { n as Spinner, t as Button } from "./button-D6Z-yLlP.js";
import { n as _elementSizeObserver, t as useElementSize } from "./useElementSize-BJvbGHq8.js";
import { a as useBoundaryElement, i as PortalContext, n as Portal, o as BoundaryElementContext, r as usePortal, t as Arrow } from "./arrow-CHE8-_G7.js";
import { t as useClickOutsideEvent } from "./useClickOutsideEvent-lEVhDFCQ.js";
import { t as responsiveCodeFontStyle } from "./codeFontStyle-DYUujk7K.js";
import { a as rgba$1, c as hslToRgb$1, i as multiply$1, l as rgbToHex$1, n as buildTheme, o as parseColor$1, r as screen$1, s as hexToRgb$1, t as createColorTheme$1, u as rgbToHsl$1 } from "./factory-BA3gEfyI.js";
import { i as useGlobalKeyDown, n as KBD, r as Inline, t as Hotkeys } from "./hotkeys-Bvex-n5O.js";
import { t as Layer } from "./layer-B98ynOf2.js";
import { t as Grid } from "./grid-BXHFJhf_.js";
import { c } from "react/compiler-runtime";
import { ChevronDownIcon } from "@sanity/icons/ChevronDown";
import { Children, Component, cloneElement, isValidElement, startTransition, useContext, useEffect, useId, useImperativeHandle, useRef, useState, useSyncExternalStore } from "react";
import { css, keyframes, styled } from "styled-components";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import ReactIs from "react-is";
import { CloseIcon } from "@sanity/icons/Close";
import { ToggleArrowRightIcon } from "@sanity/icons/ToggleArrowRight";
import { CheckmarkIcon } from "@sanity/icons/Checkmark";
import { RemoveIcon } from "@sanity/icons/Remove";
/**
* @public
* @deprecated Use `createColorTheme` from `@sanity/ui/theme` instead.
*/
const createColorTheme = createColorTheme$1, hexToRgb = hexToRgb$1, hslToRgb = hslToRgb$1, multiply = multiply$1, parseColor = parseColor$1, rgbToHex = rgbToHex$1, rgbToHsl = rgbToHsl$1, rgba = rgba$1, screen = screen$1, studioTheme = buildTheme(), BASE_STYLE = {
	width: "100%",
	margin: "0 auto"
};
function containerBaseStyle() {
	return BASE_STYLE;
}
function responsiveContainerWidthStyle(props) {
	let { container, media } = getTheme_v2(props.theme);
	return _responsive(media, props.$width, (val) => ({ maxWidth: val === "auto" ? "none" : rem(container[val]) }));
}
const StyledContainer = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledContainer",
	componentId: "sc-4jno4k-0"
})(containerBaseStyle, responsiveContainerWidthStyle);
function ContainerComponent(props) {
	let $ = c(12), as, ref, restProps, t0;
	$[0] === props ? (as = $[1], ref = $[2], restProps = $[3], t0 = $[4]) : ({as, ref, width: t0, ...restProps} = props, $[0] = props, $[1] = as, $[2] = ref, $[3] = restProps, $[4] = t0);
	let width = t0 === void 0 ? 2 : t0, t1;
	$[5] === width ? t1 = $[6] : (t1 = _getArrayProp(width), $[5] = width, $[6] = t1);
	let t2;
	return $[7] !== as || $[8] !== ref || $[9] !== restProps || $[10] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledContainer, {
		"data-ui": "Container",
		...restProps,
		$width: t1,
		forwardedAs: as,
		ref
	}), $[7] = as, $[8] = ref, $[9] = restProps, $[10] = t1, $[11] = t2) : t2 = $[11], t2;
}
/**
* The `Container` component wraps content layout in a defined set of widths.
*
* @public
*/
const Container = ContainerComponent;
function dialogStyle({ theme }) {
	let { color } = getTheme_v2(theme);
	return {
		"&:not([hidden])": { display: "flex" },
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		alignItems: "center",
		justifyContent: "center",
		outline: "none",
		background: color.backdrop
	};
}
function responsiveDialogPositionStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$position, (position) => ({ "&&": { position } }));
}
function animationDialogStyle(props) {
	return props.$animate ? css`@keyframes zoomIn{from{opacity:0;transform:scale(0.95);}to{opacity:1;transform:scale(1);}}@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}animation:fadeIn 200ms ease-out;& > [data-ui='DialogCard']{animation:zoomIn 200ms ease-out;}` : css``;
}
/**
* @internal
*/
const DialogContext = createGlobalScopedContext("@sanity/ui/context/dialog", { version: 0 });
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function useDialog() {
	return useContext(DialogContext);
}
function isTargetWithinScope(boundaryElement, portalElement, target) {
	return !boundaryElement || !portalElement || containsOrEqualsElement(boundaryElement, target) || containsOrEqualsElement(portalElement, target);
}
const StyledDialog = /* @__PURE__ */ styled(Layer).withConfig({
	displayName: "StyledDialog",
	componentId: "sc-4a2na0-0"
})(responsivePaddingStyle, dialogStyle, responsiveDialogPositionStyle, animationDialogStyle), DialogContainer = styled(Container).withConfig({
	displayName: "DialogContainer",
	componentId: "sc-4a2na0-1"
})`&:not([hidden]){display:flex;}width:100%;height:100%;flex-direction:column;align-items:center;justify-content:center;`, DialogCardRoot = styled(Card).withConfig({
	displayName: "DialogCardRoot",
	componentId: "sc-4a2na0-2"
})`&:not([hidden]){display:flex;}width:100%;min-height:0;max-height:100%;overflow:hidden;overflow:clip;`, DialogLayout = styled(Flex).withConfig({
	displayName: "DialogLayout",
	componentId: "sc-4a2na0-3"
})`flex:1;min-height:0;width:100%;`, DialogHeader = styled(Box).withConfig({
	displayName: "DialogHeader",
	componentId: "sc-4a2na0-4"
})`position:relative;z-index:2;`, DialogContent = styled(Box).withConfig({
	displayName: "DialogContent",
	componentId: "sc-4a2na0-5"
})`position:relative;z-index:1;overflow:auto;outline:none;`, DialogFooter = styled(Box).withConfig({
	displayName: "DialogFooter",
	componentId: "sc-4a2na0-6"
})`position:relative;z-index:3;`;
function DialogCard(props) {
	let $ = c(44), { __unstable_autoFocus: autoFocus, __unstable_hideCloseButton: hideCloseButton, children, contentRef: forwardedContentRef, footer, header, id, onClickOutside, onClose, portal: portalProp, radius: radiusProp, ref: forwardedRef, scheme, shadow: shadowProp, width: widthProp } = props, portal = usePortal(), portalElement = portalProp ? portal.elements?.[portalProp] || null : portal.element, boundaryElement = useBoundaryElement().element, t0;
	$[0] === radiusProp ? t0 = $[1] : (t0 = _getArrayProp(radiusProp), $[0] = radiusProp, $[1] = t0);
	let radius = t0, t1;
	$[2] === shadowProp ? t1 = $[3] : (t1 = _getArrayProp(shadowProp), $[2] = shadowProp, $[3] = t1);
	let shadow = t1, t2;
	$[4] === widthProp ? t2 = $[5] : (t2 = _getArrayProp(widthProp), $[4] = widthProp, $[5] = t2);
	let width = t2, ref = useRef(null), contentRef = useRef(null), { isTopLayer } = useLayer(), labelId = `${id}_label`, showCloseButton = !!onClose && hideCloseButton === !1, showHeader = !!header || showCloseButton, t3;
	$[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => ref.current, $[6] = t3) : t3 = $[6], useImperativeHandle(forwardedRef, t3);
	let t4;
	$[7] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => contentRef.current, $[7] = t4) : t4 = $[7], useImperativeHandle(forwardedContentRef, t4);
	let t5, t6;
	$[8] === autoFocus ? (t5 = $[9], t6 = $[10]) : (t5 = () => {
		autoFocus && ref.current && focusFirstDescendant(ref.current);
	}, t6 = [autoFocus, ref], $[8] = autoFocus, $[9] = t5, $[10] = t6), useEffect(t5, t6);
	let t7;
	$[11] !== boundaryElement || $[12] !== isTopLayer || $[13] !== onClose || $[14] !== portalElement ? (t7 = (event) => {
		if (!isTopLayer || !onClose) return;
		let target = document.activeElement;
		target && !isTargetWithinScope(boundaryElement, portalElement, target) || event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), onClose());
	}, $[11] = boundaryElement, $[12] = isTopLayer, $[13] = onClose, $[14] = portalElement, $[15] = t7) : t7 = $[15], useGlobalKeyDown(t7);
	let t8;
	$[16] !== boundaryElement || $[17] !== isTopLayer || $[18] !== onClickOutside || $[19] !== portalElement ? (t8 = isTopLayer && onClickOutside && ((event_0) => {
		let target_0 = event_0.target;
		target_0 && !isTargetWithinScope(boundaryElement, portalElement, target_0) || onClickOutside();
	}), $[16] = boundaryElement, $[17] = isTopLayer, $[18] = onClickOutside, $[19] = portalElement, $[20] = t8) : t8 = $[20];
	let t9;
	$[21] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => [ref.current], $[21] = t9) : t9 = $[21], useClickOutsideEvent(t8, t9);
	let t10;
	$[22] !== header || $[23] !== labelId || $[24] !== onClose || $[25] !== showCloseButton || $[26] !== showHeader ? (t10 = showHeader && /* @__PURE__ */ jsx(DialogHeader, { children: /* @__PURE__ */ jsxs(Flex, {
		align: "flex-start",
		padding: 3,
		children: [/* @__PURE__ */ jsx(Box, {
			flex: 1,
			padding: 2,
			children: header && /* @__PURE__ */ jsx(Text, {
				id: labelId,
				size: 1,
				weight: "semibold",
				children: header
			})
		}), showCloseButton && /* @__PURE__ */ jsx(Box, {
			flex: "none",
			children: /* @__PURE__ */ jsx(Button, {
				"aria-label": "Close dialog",
				disabled: !onClose,
				icon: CloseIcon,
				mode: "bleed",
				onClick: onClose,
				padding: 2
			})
		})]
	}) }), $[22] = header, $[23] = labelId, $[24] = onClose, $[25] = showCloseButton, $[26] = showHeader, $[27] = t10) : t10 = $[27];
	let t11;
	$[28] === children ? t11 = $[29] : (t11 = /* @__PURE__ */ jsx(DialogContent, {
		flex: 1,
		ref: contentRef,
		tabIndex: -1,
		children
	}), $[28] = children, $[29] = t11);
	let t12;
	$[30] === footer ? t12 = $[31] : (t12 = footer && /* @__PURE__ */ jsx(DialogFooter, { children: footer }), $[30] = footer, $[31] = t12);
	let t13;
	$[32] !== t10 || $[33] !== t11 || $[34] !== t12 ? (t13 = /* @__PURE__ */ jsxs(DialogLayout, {
		direction: "column",
		children: [
			t10,
			t11,
			t12
		]
	}), $[32] = t10, $[33] = t11, $[34] = t12, $[35] = t13) : t13 = $[35];
	let t14;
	$[36] !== radius || $[37] !== scheme || $[38] !== shadow || $[39] !== t13 ? (t14 = /* @__PURE__ */ jsx(DialogCardRoot, {
		radius,
		ref,
		scheme,
		shadow,
		children: t13
	}), $[36] = radius, $[37] = scheme, $[38] = shadow, $[39] = t13, $[40] = t14) : t14 = $[40];
	let t15;
	return $[41] !== t14 || $[42] !== width ? (t15 = /* @__PURE__ */ jsx(DialogContainer, {
		"data-ui": "DialogCard",
		width,
		children: t14
	}), $[41] = t14, $[42] = width, $[43] = t15) : t15 = $[43], t15;
}
/**
* The Dialog component.
*
* @public
*/
function Dialog(props) {
	let $ = c(71), dialog = useDialog(), { layer } = useTheme_v2(), _positionProp, _zOffsetProp, children, contentRef, footer, header, id, onActivate, onClickOutside, onClose, onFocus, portalProp, ref, restProps, scheme, t0, t1, t2, t3, t4, t5, t6;
	$[0] === props ? (_positionProp = $[1], _zOffsetProp = $[2], children = $[3], contentRef = $[4], footer = $[5], header = $[6], id = $[7], onActivate = $[8], onClickOutside = $[9], onClose = $[10], onFocus = $[11], portalProp = $[12], ref = $[13], restProps = $[14], scheme = $[15], t0 = $[16], t1 = $[17], t2 = $[18], t3 = $[19], t4 = $[20], t5 = $[21], t6 = $[22]) : ({__unstable_autoFocus: t0, __unstable_hideCloseButton: t1, cardRadius: t2, cardShadow: t3, children, contentRef, footer, header, id, onActivate, onClickOutside, onClose, onFocus, padding: t4, portal: portalProp, position: _positionProp, ref, scheme, width: t5, zOffset: _zOffsetProp, animate: t6, ...restProps} = props, $[0] = props, $[1] = _positionProp, $[2] = _zOffsetProp, $[3] = children, $[4] = contentRef, $[5] = footer, $[6] = header, $[7] = id, $[8] = onActivate, $[9] = onClickOutside, $[10] = onClose, $[11] = onFocus, $[12] = portalProp, $[13] = ref, $[14] = restProps, $[15] = scheme, $[16] = t0, $[17] = t1, $[18] = t2, $[19] = t3, $[20] = t4, $[21] = t5, $[22] = t6);
	let autoFocus = t0 === void 0 || t0, hideCloseButton = t1 !== void 0 && t1, cardRadiusProp = t2 === void 0 ? 4 : t2, cardShadow = t3 === void 0 ? 3 : t3, paddingProp = t4 === void 0 ? 3 : t4, widthProp = t5 === void 0 ? 0 : t5, _animate = t6 !== void 0 && t6, positionProp = _positionProp ?? (dialog.position || "fixed"), zOffsetProp = _zOffsetProp ?? (dialog.zOffset || layer.dialog.zOffset), animate = !usePrefersReducedMotion() && _animate, portal = usePortal(), portalElement = portalProp ? portal.elements?.[portalProp] || null : portal.element, boundaryElement = useBoundaryElement().element, t7;
	$[23] === cardRadiusProp ? t7 = $[24] : (t7 = _getArrayProp(cardRadiusProp), $[23] = cardRadiusProp, $[24] = t7);
	let cardRadius = t7, t8;
	$[25] === paddingProp ? t8 = $[26] : (t8 = _getArrayProp(paddingProp), $[25] = paddingProp, $[26] = t8);
	let padding = t8, t9;
	$[27] === positionProp ? t9 = $[28] : (t9 = _getArrayProp(positionProp), $[27] = positionProp, $[28] = t9);
	let position = t9, t10;
	$[29] === widthProp ? t10 = $[30] : (t10 = _getArrayProp(widthProp), $[29] = widthProp, $[30] = t10);
	let width = t10, t11;
	$[31] === zOffsetProp ? t11 = $[32] : (t11 = _getArrayProp(zOffsetProp), $[31] = zOffsetProp, $[32] = t11);
	let zOffset = t11, preDivRef = useRef(null), postDivRef = useRef(null), cardRef = useRef(null), focusedElementRef = useRef(null), t12;
	$[33] === onFocus ? t12 = $[34] : (t12 = (event) => {
		onFocus?.(event);
		let target = event.target, cardElement = cardRef.current;
		if (cardElement && target === preDivRef.current) {
			focusLastDescendant(cardElement);
			return;
		}
		if (cardElement && target === postDivRef.current) {
			focusFirstDescendant(cardElement);
			return;
		}
		isHTMLElement(event.target) && (focusedElementRef.current = event.target);
	}, $[33] = onFocus, $[34] = t12);
	let handleFocus = t12, labelId = `${id}_label`, rootClickTimeoutRef = useRef(void 0), t13;
	$[35] !== boundaryElement || $[36] !== portalElement ? (t13 = () => {
		rootClickTimeoutRef.current && clearTimeout(rootClickTimeoutRef.current), rootClickTimeoutRef.current = setTimeout(() => {
			let activeElement = document.activeElement;
			if (activeElement && !isTargetWithinScope(boundaryElement, portalElement, activeElement)) {
				let target_0 = focusedElementRef.current;
				if (!target_0 || !document.body.contains(target_0)) {
					let cardElement_0 = cardRef.current;
					cardElement_0 && focusFirstDescendant(cardElement_0);
					return;
				}
				target_0.focus();
			}
		}, 0);
	}, $[35] = boundaryElement, $[36] = portalElement, $[37] = t13) : t13 = $[37];
	let handleRootClick = t13, t14;
	$[38] === Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx("div", {
		ref: preDivRef,
		tabIndex: 0
	}), $[38] = t14) : t14 = $[38];
	let t15;
	$[39] !== autoFocus || $[40] !== cardRadius || $[41] !== cardShadow || $[42] !== children || $[43] !== contentRef || $[44] !== footer || $[45] !== header || $[46] !== hideCloseButton || $[47] !== id || $[48] !== onClickOutside || $[49] !== onClose || $[50] !== portalProp || $[51] !== scheme || $[52] !== width ? (t15 = /* @__PURE__ */ jsx(DialogCard, {
		__unstable_autoFocus: autoFocus,
		__unstable_hideCloseButton: hideCloseButton,
		contentRef,
		footer,
		header,
		id,
		onClickOutside,
		onClose,
		portal: portalProp,
		radius: cardRadius,
		ref: cardRef,
		scheme,
		shadow: cardShadow,
		width,
		children
	}), $[39] = autoFocus, $[40] = cardRadius, $[41] = cardShadow, $[42] = children, $[43] = contentRef, $[44] = footer, $[45] = header, $[46] = hideCloseButton, $[47] = id, $[48] = onClickOutside, $[49] = onClose, $[50] = portalProp, $[51] = scheme, $[52] = width, $[53] = t15) : t15 = $[53];
	let t16;
	$[54] === Symbol.for("react.memo_cache_sentinel") ? (t16 = /* @__PURE__ */ jsx("div", {
		ref: postDivRef,
		tabIndex: 0
	}), $[54] = t16) : t16 = $[54];
	let t17;
	$[55] !== animate || $[56] !== handleFocus || $[57] !== handleRootClick || $[58] !== id || $[59] !== labelId || $[60] !== onActivate || $[61] !== padding || $[62] !== position || $[63] !== ref || $[64] !== restProps || $[65] !== t15 || $[66] !== zOffset ? (t17 = /* @__PURE__ */ jsxs(StyledDialog, {
		...restProps,
		$animate: animate,
		$padding: padding,
		$position: position,
		"aria-labelledby": labelId,
		"aria-modal": !0,
		"data-ui": "Dialog",
		id,
		onActivate,
		onClick: handleRootClick,
		onFocus: handleFocus,
		ref,
		role: "dialog",
		zOffset,
		children: [
			t14,
			t15,
			t16
		]
	}), $[55] = animate, $[56] = handleFocus, $[57] = handleRootClick, $[58] = id, $[59] = labelId, $[60] = onActivate, $[61] = padding, $[62] = position, $[63] = ref, $[64] = restProps, $[65] = t15, $[66] = zOffset, $[67] = t17) : t17 = $[67];
	let t18;
	return $[68] !== portalProp || $[69] !== t17 ? (t18 = /* @__PURE__ */ jsx(Portal, {
		__unstable_name: portalProp,
		children: t17
	}), $[68] = portalProp, $[69] = t17, $[70] = t18) : t18 = $[70], t18;
}
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function DialogProvider(props) {
	let $ = c(6), { children, position, zOffset } = props, t0;
	$[0] !== position || $[1] !== zOffset ? (t0 = {
		version: 0,
		position,
		zOffset
	}, $[0] = position, $[1] = zOffset, $[2] = t0) : t0 = $[2];
	let contextValue = t0, t1;
	return $[3] !== children || $[4] !== contextValue ? (t1 = /* @__PURE__ */ jsx(DialogContext.Provider, {
		value: contextValue,
		children
	}), $[3] = children, $[4] = contextValue, $[5] = t1) : t1 = $[5], t1;
}
const keyframe = keyframes`0%{background-position:100%;}100%{background-position:-100%;}`, animation = css`background-image:linear-gradient( to right,var(--card-skeleton-color-from),var(--card-skeleton-color-to),var(--card-skeleton-color-from),var(--card-skeleton-color-from),var(--card-skeleton-color-from) );background-position:100%;background-size:200% 100%;background-attachment:fixed;animation-name:${keyframe};animation-timing-function:ease-in-out;animation-iteration-count:infinite;animation-duration:2000ms;`, skeletonStyle = css`opacity:${({ $visible }) => +!!$visible};transition:opacity 200ms ease-in;@media screen and (prefers-reduced-motion:no-preference){${({ $animated }) => $animated ? animation : css`background-color:var(--card-skeleton-color-from);`}}@media screen and (prefers-reduced-motion:reduce){background-color:var(--card-skeleton-color-from);}`, StyledSkeleton$1 = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledSkeleton",
	componentId: "sc-9cw2s-0"
})(responsiveRadiusStyle, skeletonStyle);
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function Skeleton(props) {
	let $ = c(17), delay, radius, ref, restProps, t0;
	$[0] === props ? (delay = $[1], radius = $[2], ref = $[3], restProps = $[4], t0 = $[5]) : ({animated: t0, delay, radius, ref, ...restProps} = props, $[0] = props, $[1] = delay, $[2] = radius, $[3] = ref, $[4] = restProps, $[5] = t0);
	let animated = t0 !== void 0 && t0, [visible, setVisible] = useState(!delay), t1, t2;
	$[6] === delay ? (t1 = $[7], t2 = $[8]) : (t1 = () => {
		if (!delay) return;
		let timeout = setTimeout(() => {
			setVisible(!0);
		}, delay);
		return () => {
			clearTimeout(timeout);
		};
	}, t2 = [delay], $[6] = delay, $[7] = t1, $[8] = t2), useEffect(t1, t2);
	let t3;
	$[9] === radius ? t3 = $[10] : (t3 = _getArrayProp(radius), $[9] = radius, $[10] = t3);
	let t4 = !delay || visible, t5;
	return $[11] !== animated || $[12] !== ref || $[13] !== restProps || $[14] !== t3 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(StyledSkeleton$1, {
		...restProps,
		$animated: animated,
		$radius: t3,
		$visible: t4,
		ref
	}), $[11] = animated, $[12] = ref, $[13] = restProps, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
}
const StyledSkeleton = /* @__PURE__ */ styled(Skeleton).withConfig({
	displayName: "StyledSkeleton",
	componentId: "sc-dq8t4f-0"
})((props) => {
	let { $size, $style } = props, { font, media } = getTheme_v2(props.theme), fontStyle = font[$style];
	return _responsive(media, $size, (sizeIndex) => {
		let fontSize = fontStyle.sizes[sizeIndex];
		return { height: fontSize.lineHeight - fontSize.ascenderHeight - fontSize.descenderHeight };
	});
});
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function TextSkeleton(props) {
	let $ = c(8), restProps, t0;
	$[0] === props ? (restProps = $[1], t0 = $[2]) : ({size: t0, ...restProps} = props, $[0] = props, $[1] = restProps, $[2] = t0);
	let size = t0 === void 0 ? 2 : t0, t1;
	$[3] === size ? t1 = $[4] : (t1 = _getArrayProp(size), $[3] = size, $[4] = t1);
	let $size = t1, t2;
	return $[5] !== $size || $[6] !== restProps ? (t2 = /* @__PURE__ */ jsx(StyledSkeleton, {
		...restProps,
		$size,
		$style: "text"
	}), $[5] = $size, $[6] = restProps, $[7] = t2) : t2 = $[7], t2;
}
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function LabelSkeleton(props) {
	let $ = c(8), restProps, t0;
	$[0] === props ? (restProps = $[1], t0 = $[2]) : ({size: t0, ...restProps} = props, $[0] = props, $[1] = restProps, $[2] = t0);
	let size = t0 === void 0 ? 2 : t0, t1;
	$[3] === size ? t1 = $[4] : (t1 = _getArrayProp(size), $[3] = size, $[4] = t1);
	let $size = t1, t2;
	return $[5] !== $size || $[6] !== restProps ? (t2 = /* @__PURE__ */ jsx(StyledSkeleton, {
		...restProps,
		$size,
		$style: "label"
	}), $[5] = $size, $[6] = restProps, $[7] = t2) : t2 = $[7], t2;
}
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function HeadingSkeleton(props) {
	let $ = c(8), restProps, t0;
	$[0] === props ? (restProps = $[1], t0 = $[2]) : ({size: t0, ...restProps} = props, $[0] = props, $[1] = restProps, $[2] = t0);
	let size = t0 === void 0 ? 2 : t0, t1;
	$[3] === size ? t1 = $[4] : (t1 = _getArrayProp(size), $[3] = size, $[4] = t1);
	let $size = t1, t2;
	return $[5] !== $size || $[6] !== restProps ? (t2 = /* @__PURE__ */ jsx(StyledSkeleton, {
		...restProps,
		$size,
		$style: "heading"
	}), $[5] = $size, $[6] = restProps, $[7] = t2) : t2 = $[7], t2;
}
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function CodeSkeleton(props) {
	let $ = c(8), restProps, t0;
	$[0] === props ? (restProps = $[1], t0 = $[2]) : ({size: t0, ...restProps} = props, $[0] = props, $[1] = restProps, $[2] = t0);
	let size = t0 === void 0 ? 2 : t0, t1;
	$[3] === size ? t1 = $[4] : (t1 = _getArrayProp(size), $[3] = size, $[4] = t1);
	let $size = t1, t2;
	return $[5] !== $size || $[6] !== restProps ? (t2 = /* @__PURE__ */ jsx(StyledSkeleton, {
		...restProps,
		$size,
		$style: "code"
	}), $[5] = $size, $[6] = restProps, $[7] = t2) : t2 = $[7], t2;
}
const CustomButton = styled(Button).withConfig({
	displayName: "CustomButton",
	componentId: "sc-bacfyt-0"
})`max-width:100%;`;
/**
* @public
*/
function Tab(props) {
	let $ = c(31), focused, forwardedRef, icon, id, label, onClick, onFocus, restProps, selected, t0, t1;
	$[0] === props ? (focused = $[1], forwardedRef = $[2], icon = $[3], id = $[4], label = $[5], onClick = $[6], onFocus = $[7], restProps = $[8], selected = $[9], t0 = $[10], t1 = $[11]) : ({icon, id, focused, fontSize: t0, label, onClick, onFocus, padding: t1, ref: forwardedRef, selected, ...restProps} = props, $[0] = props, $[1] = focused, $[2] = forwardedRef, $[3] = icon, $[4] = id, $[5] = label, $[6] = onClick, $[7] = onFocus, $[8] = restProps, $[9] = selected, $[10] = t0, $[11] = t1);
	let fontSize = t0 === void 0 ? 1 : t0, padding = t1 === void 0 ? 2 : t1, ref = useRef(null), focusedRef = useRef(!1), t2;
	$[12] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ref.current, $[12] = t2) : t2 = $[12], useImperativeHandle(forwardedRef, t2);
	let t3;
	$[13] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
		focusedRef.current = !1;
	}, $[13] = t3) : t3 = $[13];
	let handleBlur = t3, t4;
	$[14] === onFocus ? t4 = $[15] : (t4 = (event) => {
		focusedRef.current = !0, onFocus && onFocus(event);
	}, $[14] = onFocus, $[15] = t4);
	let handleFocus = t4, t5, t6;
	$[16] === focused ? (t5 = $[17], t6 = $[18]) : (t5 = () => {
		focused && !focusedRef.current && (ref.current && ref.current.focus(), focusedRef.current = !0);
	}, t6 = [focused], $[16] = focused, $[17] = t5, $[18] = t6), useEffect(t5, t6);
	let t7 = selected ? "true" : "false", t8 = selected ? 0 : -1, t9;
	return $[19] !== fontSize || $[20] !== handleFocus || $[21] !== icon || $[22] !== id || $[23] !== label || $[24] !== onClick || $[25] !== padding || $[26] !== restProps || $[27] !== selected || $[28] !== t7 || $[29] !== t8 ? (t9 = /* @__PURE__ */ jsx(CustomButton, {
		"data-ui": "Tab",
		...restProps,
		"aria-selected": t7,
		fontSize,
		icon,
		id,
		mode: "bleed",
		onClick,
		onBlur: handleBlur,
		onFocus: handleFocus,
		padding,
		ref,
		role: "tab",
		selected,
		tabIndex: t8,
		text: label,
		type: "button"
	}), $[19] = fontSize, $[20] = handleFocus, $[21] = icon, $[22] = id, $[23] = label, $[24] = onClick, $[25] = padding, $[26] = restProps, $[27] = selected, $[28] = t7, $[29] = t8, $[30] = t9) : t9 = $[30], t9;
}
const CustomInline = styled(Inline).withConfig({
	displayName: "CustomInline",
	componentId: "sc-uahcjl-0"
})`& > div{display:inline-block;vertical-align:middle;max-width:100%;box-sizing:border-box;}`;
/**
* @public
*/
function TabList(props) {
	let $ = c(16), childrenProp, ref, restProps;
	$[0] === props ? (childrenProp = $[1], ref = $[2], restProps = $[3]) : ({children: childrenProp, ref, ...restProps} = props, $[0] = props, $[1] = childrenProp, $[2] = ref, $[3] = restProps);
	let [focusedIndex, setFocusedIndex] = useState(-1), t0;
	if ($[4] !== childrenProp || $[5] !== focusedIndex) {
		let children = Children.toArray(childrenProp).filter(isValidElement), t1;
		$[7] === focusedIndex ? t1 = $[8] : (t1 = (child, childIndex) => cloneElement(child, {
			focused: focusedIndex === childIndex,
			key: childIndex,
			onFocus: () => setFocusedIndex(childIndex)
		}), $[7] = focusedIndex, $[8] = t1), t0 = children.map(t1), $[4] = childrenProp, $[5] = focusedIndex, $[6] = t0;
	} else t0 = $[6];
	let tabs = t0, numTabs = tabs.length, t1;
	$[9] === numTabs ? t1 = $[10] : (t1 = (event) => {
		event.key === "ArrowLeft" && setFocusedIndex((prevIndex) => (prevIndex + numTabs - 1) % numTabs), event.key === "ArrowRight" && setFocusedIndex((prevIndex_0) => (prevIndex_0 + 1) % numTabs);
	}, $[9] = numTabs, $[10] = t1);
	let handleKeyDown = t1, t2;
	return $[11] !== handleKeyDown || $[12] !== ref || $[13] !== restProps || $[14] !== tabs ? (t2 = /* @__PURE__ */ jsx(CustomInline, {
		"data-ui": "TabList",
		...restProps,
		onKeyDown: handleKeyDown,
		ref,
		role: "tablist",
		children: tabs
	}), $[11] = handleKeyDown, $[12] = ref, $[13] = restProps, $[14] = tabs, $[15] = t2) : t2 = $[15], t2;
}
/**
* @public
*/
function TabPanel(props) {
	let $ = c(8), flex, restProps;
	$[0] === props ? (flex = $[1], restProps = $[2]) : ({flex, ...restProps} = props, $[0] = props, $[1] = flex, $[2] = restProps);
	let t0 = props.tabIndex === void 0 ? 0 : props.tabIndex, t1;
	return $[3] !== flex || $[4] !== props.children || $[5] !== restProps || $[6] !== t0 ? (t1 = /* @__PURE__ */ jsx(Box, {
		"data-ui": "TabPanel",
		...restProps,
		flex,
		role: "tabpanel",
		tabIndex: t0,
		children: props.children
	}), $[3] = flex, $[4] = props.children, $[5] = restProps, $[6] = t0, $[7] = t1) : t1 = $[7], t1;
}
function _findPrevItemElement(state, itemElements, focusedElement) {
	let idx = itemElements.indexOf(focusedElement), els = itemElements.slice(0, idx), len = els.length;
	for (let i = len - 1; i >= 0; --i) {
		let itemKey = els[i].getAttribute("data-tree-key");
		if (!itemKey) continue;
		let segments = itemKey.split("/");
		segments.pop();
		let p = [], expanded = !0;
		for (let j = 0; j < segments.length; j += 1) if (p.push(segments[j]), !state[p.join("/")]?.expanded) {
			expanded = !1;
			break;
		}
		if (expanded) return els[i];
	}
	return null;
}
function _findNextItemElement(state, itemElements, focusedElement) {
	let idx = itemElements.indexOf(focusedElement), els = itemElements.slice(idx), len = itemElements.length;
	for (let i = 1; i < len; i += 1) {
		if (!els[i]) continue;
		let itemKey = els[i].getAttribute("data-tree-key");
		if (!itemKey) continue;
		let segments = itemKey.split("/");
		segments.pop();
		let p = [], expanded = !0;
		for (let j = 0; j < segments.length; j += 1) if (p.push(segments[j]), !state[p.join("/")]?.expanded) {
			expanded = !1;
			break;
		}
		if (expanded) return els[i];
	}
	return null;
}
function _focusItemElement(el) {
	if (el.getAttribute("role") === "treeitem" && el.focus(), el.getAttribute("role") === "none") {
		let firstChild = el.firstChild;
		firstChild && firstChild instanceof HTMLElement && firstChild.focus();
	}
}
/**
* @internal
*/
const TreeContext = createGlobalScopedContext("@sanity/ui/context/tree", null);
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function Tree(props) {
	let $ = c(38), children, forwardedRef, onFocus, restProps, t0;
	$[0] === props ? (children = $[1], forwardedRef = $[2], onFocus = $[3], restProps = $[4], t0 = $[5]) : ({children, gap: t0, onFocus, ref: forwardedRef, ...restProps} = props, $[0] = props, $[1] = children, $[2] = forwardedRef, $[3] = onFocus, $[4] = restProps, $[5] = t0);
	let gap = t0 === void 0 ? 1 : t0, ref = useRef(null), [focusedElement, setFocusedElement] = useState(null), focusedElementRef = useRef(focusedElement), t1;
	$[6] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[6] = t1) : t1 = $[6];
	let path = t1, t2;
	$[7] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[7] = t2) : t2 = $[7];
	let [itemElements, setItemElements] = useState(t2), t3;
	$[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {}, $[8] = t3) : t3 = $[8];
	let [state, setState] = useState(t3), stateRef = useRef(state), t4;
	$[9] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => ref.current, $[9] = t4) : t4 = $[9], useImperativeHandle(forwardedRef, t4);
	let t5, t6;
	$[10] === focusedElement ? (t5 = $[11], t6 = $[12]) : (t5 = () => {
		focusedElementRef.current = focusedElement;
	}, t6 = [focusedElement], $[10] = focusedElement, $[11] = t5, $[12] = t6), useEffect(t5, t6);
	let t7, t8;
	$[13] === state ? (t7 = $[14], t8 = $[15]) : (t7 = () => {
		stateRef.current = state;
	}, t8 = [state], $[13] = state, $[14] = t7, $[15] = t8), useEffect(t7, t8);
	let t9;
	$[16] === Symbol.for("react.memo_cache_sentinel") ? (t9 = (element, path_0, expanded, selected) => (setState((s) => ({
		...s,
		[path_0]: {
			element,
			expanded
		}
	})), selected && setFocusedElement(element), () => {
		setState((s_0) => {
			let newState = { ...s_0 };
			return delete newState[path_0], newState;
		});
	}), $[16] = t9) : t9 = $[16];
	let registerItem = t9, t10;
	$[17] === Symbol.for("react.memo_cache_sentinel") ? (t10 = (path_1, expanded_0) => {
		setState((s_1) => {
			let itemState = s_1[path_1];
			return itemState ? {
				...s_1,
				[path_1]: {
					...itemState,
					expanded: expanded_0
				}
			} : s_1;
		});
	}, $[17] = t10) : t10 = $[17];
	let setExpanded = t10, t11 = focusedElement || itemElements[0] || null, t12;
	$[18] !== gap || $[19] !== state || $[20] !== t11 ? (t12 = {
		version: 0,
		focusedElement: t11,
		level: 0,
		path,
		registerItem,
		setExpanded,
		setFocusedElement,
		gap,
		state
	}, $[18] = gap, $[19] = state, $[20] = t11, $[21] = t12) : t12 = $[21];
	let contextValue = t12, t13;
	$[22] === itemElements ? t13 = $[23] : (t13 = (event) => {
		if (focusedElementRef.current) {
			if (event.key === "ArrowDown") {
				event.preventDefault();
				let nextEl = _findNextItemElement(stateRef.current, itemElements, focusedElementRef.current);
				nextEl && (_focusItemElement(nextEl), setFocusedElement(nextEl));
				return;
			}
			if (event.key === "ArrowUp") {
				event.preventDefault();
				let prevEl = _findPrevItemElement(stateRef.current, itemElements, focusedElementRef.current);
				prevEl && (_focusItemElement(prevEl), setFocusedElement(prevEl));
				return;
			}
			if (event.key === "ArrowLeft") {
				event.preventDefault();
				let itemKey = focusedElementRef.current.getAttribute("data-tree-key");
				if (!itemKey) return;
				let itemState_0 = stateRef.current[itemKey];
				if (!itemState_0) return;
				if (itemState_0.expanded) setState((s_2) => {
					let itemState_1 = s_2[itemKey];
					return itemState_1 ? {
						...s_2,
						[itemKey]: {
							...itemState_1,
							expanded: !1
						}
					} : s_2;
				});
				else {
					let itemPath = itemKey.split("/");
					itemPath.pop();
					let parentKey = itemPath.join("/"), parentState = parentKey && stateRef.current[parentKey];
					parentState && (parentState.element.focus(), setFocusedElement(parentState.element));
				}
				return;
			}
			if (event.key === "ArrowRight") {
				event.preventDefault();
				let focusedKey = focusedElementRef.current.getAttribute("data-tree-key");
				if (!focusedKey) return;
				stateRef.current[focusedKey]?.expanded || setState((s_3) => {
					let itemState_2 = s_3[focusedKey];
					return itemState_2 ? {
						...s_3,
						[focusedKey]: {
							...itemState_2,
							expanded: !0
						}
					} : s_3;
				});
				return;
			}
		}
	}, $[22] = itemElements, $[23] = t13);
	let handleKeyDown = t13, t14;
	$[24] === onFocus ? t14 = $[25] : (t14 = (event_0) => {
		setFocusedElement(event_0.target), onFocus?.(event_0);
	}, $[24] = onFocus, $[25] = t14);
	let handleFocus = t14, t15;
	$[26] === Symbol.for("react.memo_cache_sentinel") ? (t15 = () => {
		if (!ref.current) return;
		let _itemElements = Array.from(ref.current.querySelectorAll("[data-ui=\"TreeItem\"]"));
		setItemElements(_itemElements);
	}, $[26] = t15) : t15 = $[26];
	let t16;
	$[27] === children ? t16 = $[28] : (t16 = [children], $[27] = children, $[28] = t16), useEffect(t15, t16);
	let t17;
	$[29] !== children || $[30] !== gap || $[31] !== handleFocus || $[32] !== handleKeyDown || $[33] !== restProps ? (t17 = /* @__PURE__ */ jsx(Stack, {
		as: "ul",
		"data-ui": "Tree",
		...restProps,
		onFocus: handleFocus,
		onKeyDown: handleKeyDown,
		ref,
		role: "tree",
		gap,
		children
	}), $[29] = children, $[30] = gap, $[31] = handleFocus, $[32] = handleKeyDown, $[33] = restProps, $[34] = t17) : t17 = $[34];
	let t18;
	return $[35] !== contextValue || $[36] !== t17 ? (t18 = /* @__PURE__ */ jsx(TreeContext.Provider, {
		value: contextValue,
		children: t17
	}), $[35] = contextValue, $[36] = t17, $[37] = t18) : t18 = $[37], t18;
}
function treeItemRootStyle() {
	return css`&[role='none'] > [role='treeitem']{outline:none;cursor:default;border-radius:3px;background-color:var(--card-bg-color);color:var(--treeitem-fg-color);&:focus{position:relative;}}&[role='treeitem']{outline:none;& > div{cursor:default;border-radius:3px;background-color:var(--card-bg-color);color:var(--treeitem-fg-color);}&:focus > div{position:relative;}}`;
}
function treeItemRootColorStyle(props) {
	let { color } = getTheme_v2(props.theme), tone = color.selectable.default;
	return css`&[role='none']{& > [role='treeitem']{${_cardColorStyle(color, tone.enabled)}}&[data-selected] > [role='treeitem']{${_cardColorStyle(color, tone.pressed)}}@media (hover:hover){&:not([data-selected]) > [role='treeitem']:not(:focus):hover{${_cardColorStyle(color, tone.hovered)}}& > [role='treeitem']:focus{${_cardColorStyle(color, tone.selected)}}}}&[role='treeitem']{& > [data-ui='TreeItem__box']{${_cardColorStyle(color, tone.enabled)}}&[data-selected] > [data-ui='TreeItem__box']{${_cardColorStyle(color, tone.pressed)}}@media (hover:hover){&:not([data-selected]):not(:focus) > [data-ui='TreeItem__box']:hover{${_cardColorStyle(color, tone.hovered)}}&:focus > [data-ui='TreeItem__box']{${_cardColorStyle(color, tone.selected)}}}}`;
}
function treeItemBoxStyle(props) {
	let { $level } = props, { space } = getTheme_v2(props.theme);
	return css`display:block;padding-left:${rem(space[2] * $level)};text-decoration:none;`;
}
/**
* @beta
*/
function useTree() {
	let tree = useContext(TreeContext);
	if (!tree) throw Error("Tree: missing context value");
	return tree;
}
function TreeGroup(props) {
	let $ = c(9), children, restProps, t0;
	$[0] === props ? (children = $[1], restProps = $[2], t0 = $[3]) : ({children, expanded: t0, ...restProps} = props, $[0] = props, $[1] = children, $[2] = restProps, $[3] = t0);
	let expanded = t0 !== void 0 && t0, tree = useTree(), t1 = !expanded, t2;
	return $[4] !== children || $[5] !== restProps || $[6] !== t1 || $[7] !== tree.gap ? (t2 = /* @__PURE__ */ jsx(Stack, {
		as: "ul",
		"data-ui": "TreeGroup",
		...restProps,
		hidden: t1,
		marginTop: tree.gap,
		role: "group",
		gap: tree.gap,
		children
	}), $[4] = children, $[5] = restProps, $[6] = t1, $[7] = tree.gap, $[8] = t2) : t2 = $[8], t2;
}
const StyledTreeItem = /* @__PURE__ */ styled.li.withConfig({
	displayName: "StyledTreeItem",
	componentId: "sc-d4xra6-0"
})(treeItemRootStyle, treeItemRootColorStyle), TreeItemBox = /* @__PURE__ */ styled.a.withConfig({
	displayName: "TreeItemBox",
	componentId: "sc-d4xra6-1"
})(treeItemBoxStyle), ToggleArrowText = styled(Text).withConfig({
	displayName: "ToggleArrowText",
	componentId: "sc-d4xra6-2"
})`& > svg{transition:transform 100ms;}`;
/**
* This API might change. DO NOT USE IN PRODUCTION.
* @beta
*/
function TreeItem(props) {
	let $ = c(116), IconComponent, children, href, idProp, linkAs, linkProps, muted, onClick, restProps, t0, t1, t2, t3, t4, text, weight;
	$[0] === props ? (IconComponent = $[1], children = $[2], href = $[3], idProp = $[4], linkAs = $[5], linkProps = $[6], muted = $[7], onClick = $[8], restProps = $[9], t0 = $[10], t1 = $[11], t2 = $[12], t3 = $[13], t4 = $[14], text = $[15], weight = $[16]) : ({children, expanded: t0, fontSize: t1, href, icon: IconComponent, id: idProp, linkAs, linkProps, muted, onClick, padding: t2, selected: t3, gap: t4, text, weight, ...restProps} = props, $[0] = props, $[1] = IconComponent, $[2] = children, $[3] = href, $[4] = idProp, $[5] = linkAs, $[6] = linkProps, $[7] = muted, $[8] = onClick, $[9] = restProps, $[10] = t0, $[11] = t1, $[12] = t2, $[13] = t3, $[14] = t4, $[15] = text, $[16] = weight);
	let expandedProp = t0 !== void 0 && t0, fontSize = t1 === void 0 ? 1 : t1, padding = t2 === void 0 ? 2 : t2, selected = t3 !== void 0 && t3, gap = t4 === void 0 ? 2 : t4, [rootElement, _setRootElement] = useState(null), t5;
	$[17] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (node) => {
		startTransition(() => _setRootElement(node));
	}, $[17] = t5) : t5 = $[17];
	let setRootElement = t5, treeitemRef = useRef(null), tree = useTree(), { path, registerItem, setExpanded, setFocusedElement } = tree, _id = useId(), id = idProp || _id, t6, t7;
	if ($[18] !== id || $[19] !== path) {
		let itemPath = path.concat([id || ""]);
		t6 = itemPath, t7 = itemPath.join("/"), $[18] = id, $[19] = path, $[20] = t6, $[21] = t7;
	} else t6 = $[20], t7 = $[21];
	let t8;
	$[22] !== t6 || $[23] !== t7 ? (t8 = [t6, t7], $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24];
	let [itemPath_0, itemKey] = t8, itemState = tree.state[itemKey], focused = tree.focusedElement === rootElement, expanded = itemState?.expanded === void 0 ? expandedProp : itemState?.expanded || !1, tabIndex = tree.focusedElement && tree.focusedElement === rootElement ? 0 : -1, t9 = tree.level + 1, t10;
	$[25] !== itemPath_0 || $[26] !== t9 || $[27] !== tree ? (t10 = {
		...tree,
		level: t9,
		path: itemPath_0
	}, $[25] = itemPath_0, $[26] = t9, $[27] = tree, $[28] = t10) : t10 = $[28];
	let contextValue = t10, t11;
	$[29] !== expanded || $[30] !== itemKey || $[31] !== onClick || $[32] !== rootElement || $[33] !== setExpanded || $[34] !== setFocusedElement ? (t11 = (event) => {
		onClick && onClick(event);
		let target = event.target;
		target instanceof HTMLElement && (target.getAttribute("data-ui") === "TreeItem" || target.closest("[data-ui=\"TreeItem__box\"]")) && (event.stopPropagation(), setExpanded(itemKey, !expanded), setFocusedElement(rootElement));
	}, $[29] = expanded, $[30] = itemKey, $[31] = onClick, $[32] = rootElement, $[33] = setExpanded, $[34] = setFocusedElement, $[35] = t11) : t11 = $[35];
	let handleClick = t11, t12;
	$[36] !== focused || $[37] !== rootElement ? (t12 = (event_0) => {
		focused && event_0.key === "Enter" && (treeitemRef.current || rootElement)?.click();
	}, $[36] = focused, $[37] = rootElement, $[38] = t12) : t12 = $[38];
	let handleKeyDown = t12, t13, t14;
	$[39] !== expanded || $[40] !== itemKey || $[41] !== registerItem || $[42] !== rootElement || $[43] !== selected ? (t13 = () => {
		if (rootElement) return registerItem(rootElement, itemKey, expanded, selected);
	}, t14 = [
		expanded,
		itemKey,
		registerItem,
		rootElement,
		selected
	], $[39] = expanded, $[40] = itemKey, $[41] = registerItem, $[42] = rootElement, $[43] = selected, $[44] = t13, $[45] = t14) : (t13 = $[44], t14 = $[45]), useEffect(t13, t14);
	let t15 = IconComponent || children ? "visible" : "hidden", t16;
	$[46] === t15 ? t16 = $[47] : (t16 = {
		visibility: t15,
		pointerEvents: "none"
	}, $[46] = t15, $[47] = t16);
	let t17;
	$[48] !== IconComponent || $[49] !== fontSize || $[50] !== muted || $[51] !== weight ? (t17 = IconComponent && /* @__PURE__ */ jsx(Text, {
		muted,
		size: fontSize,
		weight,
		children: /* @__PURE__ */ jsx(IconComponent, {})
	}), $[48] = IconComponent, $[49] = fontSize, $[50] = muted, $[51] = weight, $[52] = t17) : t17 = $[52];
	let t18;
	$[53] !== IconComponent || $[54] !== expanded || $[55] !== fontSize || $[56] !== muted || $[57] !== weight ? (t18 = !IconComponent && /* @__PURE__ */ jsx(ToggleArrowText, {
		muted,
		size: fontSize,
		weight,
		children: /* @__PURE__ */ jsx(ToggleArrowRightIcon, { style: { transform: expanded ? "rotate(90deg)" : void 0 } })
	}), $[53] = IconComponent, $[54] = expanded, $[55] = fontSize, $[56] = muted, $[57] = weight, $[58] = t18) : t18 = $[58];
	let t19;
	$[59] !== gap || $[60] !== t16 || $[61] !== t17 || $[62] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Box, {
		marginRight: gap,
		style: t16,
		children: [t17, t18]
	}), $[59] = gap, $[60] = t16, $[61] = t17, $[62] = t18, $[63] = t19) : t19 = $[63];
	let t20;
	$[64] !== fontSize || $[65] !== muted || $[66] !== text || $[67] !== weight ? (t20 = /* @__PURE__ */ jsx(Box, {
		flex: 1,
		children: /* @__PURE__ */ jsx(Text, {
			muted,
			size: fontSize,
			textOverflow: "ellipsis",
			weight,
			children: text
		})
	}), $[64] = fontSize, $[65] = muted, $[66] = text, $[67] = weight, $[68] = t20) : t20 = $[68];
	let t21;
	$[69] !== padding || $[70] !== t19 || $[71] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Flex, {
		padding,
		children: [t19, t20]
	}), $[69] = padding, $[70] = t19, $[71] = t20, $[72] = t21) : t21 = $[72];
	let content = t21;
	if (href) {
		let t22 = selected ? "" : void 0, t23 = typeof linkAs == "string" ? linkAs : "a", t24;
		$[73] !== content || $[74] !== expanded || $[75] !== href || $[76] !== linkAs || $[77] !== linkProps || $[78] !== t23 || $[79] !== tabIndex || $[80] !== tree.level ? (t24 = /* @__PURE__ */ jsx(TreeItemBox, {
			...linkProps,
			$level: tree.level,
			"aria-expanded": expanded,
			as: linkAs,
			"data-as": t23,
			"data-ui": "TreeItem__box",
			href,
			ref: treeitemRef,
			role: "treeitem",
			tabIndex,
			children: content
		}), $[73] = content, $[74] = expanded, $[75] = href, $[76] = linkAs, $[77] = linkProps, $[78] = t23, $[79] = tabIndex, $[80] = tree.level, $[81] = t24) : t24 = $[81];
		let t25;
		$[82] !== children || $[83] !== expanded ? (t25 = children && /* @__PURE__ */ jsx(TreeGroup, {
			hidden: !expanded,
			children
		}), $[82] = children, $[83] = expanded, $[84] = t25) : t25 = $[84];
		let t26;
		$[85] !== contextValue || $[86] !== t25 ? (t26 = /* @__PURE__ */ jsx(TreeContext.Provider, {
			value: contextValue,
			children: t25
		}), $[85] = contextValue, $[86] = t25, $[87] = t26) : t26 = $[87];
		let t27;
		return $[88] !== handleClick || $[89] !== id || $[90] !== itemKey || $[91] !== restProps || $[92] !== t22 || $[93] !== t24 || $[94] !== t26 ? (t27 = /* @__PURE__ */ jsxs(StyledTreeItem, {
			"data-selected": t22,
			"data-tree-id": id,
			"data-tree-key": itemKey,
			"data-ui": "TreeItem",
			...restProps,
			onClick: handleClick,
			ref: setRootElement,
			role: "none",
			children: [t24, t26]
		}), $[88] = handleClick, $[89] = id, $[90] = itemKey, $[91] = restProps, $[92] = t22, $[93] = t24, $[94] = t26, $[95] = t27) : t27 = $[95], t27;
	}
	let t22 = selected ? "" : void 0, t23;
	$[96] !== content || $[97] !== tree.level ? (t23 = /* @__PURE__ */ jsx(TreeItemBox, {
		$level: tree.level,
		as: "div",
		"data-ui": "TreeItem__box",
		children: content
	}), $[96] = content, $[97] = tree.level, $[98] = t23) : t23 = $[98];
	let t24;
	$[99] !== children || $[100] !== expanded ? (t24 = children && /* @__PURE__ */ jsx(TreeGroup, {
		expanded,
		children
	}), $[99] = children, $[100] = expanded, $[101] = t24) : t24 = $[101];
	let t25;
	$[102] !== contextValue || $[103] !== t24 ? (t25 = /* @__PURE__ */ jsx(TreeContext.Provider, {
		value: contextValue,
		children: t24
	}), $[102] = contextValue, $[103] = t24, $[104] = t25) : t25 = $[104];
	let t26;
	return $[105] !== expanded || $[106] !== handleClick || $[107] !== handleKeyDown || $[108] !== id || $[109] !== itemKey || $[110] !== restProps || $[111] !== t22 || $[112] !== t23 || $[113] !== t25 || $[114] !== tabIndex ? (t26 = /* @__PURE__ */ jsxs(StyledTreeItem, {
		"data-selected": t22,
		"data-ui": "TreeItem",
		"data-tree-id": id,
		"data-tree-key": itemKey,
		...restProps,
		"aria-expanded": expanded,
		onClick: handleClick,
		onKeyDown: handleKeyDown,
		ref: setRootElement,
		role: "treeitem",
		tabIndex,
		children: [t23, t25]
	}), $[105] = expanded, $[106] = handleClick, $[107] = handleKeyDown, $[108] = id, $[109] = itemKey, $[110] = restProps, $[111] = t22, $[112] = t23, $[113] = t25, $[114] = tabIndex, $[115] = t26) : t26 = $[115], t26;
}
/**
* @internal
*/
function _isScrollable(el) {
	if (!(el instanceof Element)) return !1;
	let style = window.getComputedStyle(el);
	return style.overflowX.includes("auto") || style.overflowX.includes("scroll") || style.overflowY.includes("auto") || style.overflowY.includes("scroll");
}
/**
* @deprecated instead of `useArrayProp(width)` use `Array.isArray(width) ? width : [width]` instead
* @beta
*/
function useArrayProp(_val, _defaultVal) {
	throw Error("`useArrayProp` was removed in @sanity/ui v4. Use `Array.isArray(value) ? value : [value]` instead.");
}
/**
* @public
* @deprecated replaced by the new `useClickOutsideEvent` hook, instead of:
* ```tsx
* const [button, setButtonElement] = useState(null)
* useClickOutside((event) => {}, [button])
* return <button ref={setButtonElement} />
* ```
* do:
* ```tsx
* const buttonRef = useRef()
* useClickOutsideEvent((event) => {}, () => [buttonRef.current])
* return <button ref={buttonRef} />
* ```
*/
function useClickOutside(_listener, _elementsArg, _boundaryElement) {
	throw Error("`useClickOutside` was removed in @sanity/ui v4. Use `useClickOutsideEvent` instead.");
}
/**
* Subscribe to the rect of a DOM element.
* @beta
*
* @deprecated Use `useElementSize` instead
*/
function useElementRect(_element) {
	throw Error("`useElementRect` was removed in @sanity/ui v4. Use `useElementSize` instead.");
}
/**
* @beta
* @deprecated use `useImperativeHandle` instead
* @example
* ```diff
* -const ref = useForwardedRef(forwardedRef)
* +const ref = useRef(null)
* +useImperativeHandle(forwardedRef, () => ref.current)
* ```
*/
function useForwardedRef(_ref) {
	throw Error("`useForwardedRef` was removed in @sanity/ui v4. Use `useRef` and `useImperativeHandle` instead.");
}
/**
* Returns true if a dark color scheme is preferred, false if a light color scheme is preferred or the preference is not known.
*
* @param getServerSnapshot - Only called during server-side rendering, and hydration if using hydrateRoot. Since the server environment doesn't have access to the DOM, we can't determine the current value of the media query and we assume `(prefers-color-scheme: light)` since it's the most common scheme (https://react.dev/reference/react/useSyncExternalStore#adding-support-for-server-rendering)
*
* If you persist the detected preference in a cookie or a header then you may implement your own server snapshot to read it.
* Chrome supports reading the `prefers-color-scheme` media query from a header if the server response: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-Prefers-Color-Scheme
* @example https://gist.github.com/stipsan/13c0cccf8dfc34f4b44bb1b984baf7df
*
* @public
*/
function usePrefersDark(t0) {
	return useMatchMedia("(prefers-color-scheme: dark)", t0 === void 0 ? _temp$3 : t0);
}
function _temp$3() {
	return !1;
}
/**
* Get responsive CSS for the `label` font style.
* @internal
*/
function responsiveLabelFont(props) {
	return responsiveFont("label", props);
}
function labelBaseStyle(props) {
	let { $accent, $muted } = props, { font } = getTheme_v2(props.theme);
	return css`text-transform:uppercase;${$accent && css`color:var(--card-accent-fg-color);`} ${$muted && css`color:var(--card-muted-fg-color);`} & code{font-family:${font.code.family};border-radius:1px;}& a{text-decoration:none;border-radius:1px;}& svg{display:inline;max-width:unset;}& [data-sanity-icon]{vertical-align:baseline;}`;
}
const StyledLabel = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledLabel",
	componentId: "sc-73f3t9-0"
})(responsiveLabelFont, responsiveTextAlignStyle, labelBaseStyle);
function LabelComponent(props) {
	let $ = c(27), accent, align, childrenProp, ref, restProps, t0, t1, textOverflow, weight;
	$[0] === props ? (accent = $[1], align = $[2], childrenProp = $[3], ref = $[4], restProps = $[5], t0 = $[6], t1 = $[7], textOverflow = $[8], weight = $[9]) : ({accent, align, children: childrenProp, muted: t0, ref, size: t1, textOverflow, weight, ...restProps} = props, $[0] = props, $[1] = accent, $[2] = align, $[3] = childrenProp, $[4] = ref, $[5] = restProps, $[6] = t0, $[7] = t1, $[8] = textOverflow, $[9] = weight);
	let muted = t0 !== void 0 && t0, size = t1 === void 0 ? 2 : t1, children = childrenProp;
	if (textOverflow === "ellipsis") {
		let t2;
		$[10] === children ? t2 = $[11] : (t2 = /* @__PURE__ */ jsx(SpanWithTextOverflow, { children }), $[10] = children, $[11] = t2), children = t2;
	} else {
		let t2;
		$[12] === children ? t2 = $[13] : (t2 = /* @__PURE__ */ jsx("span", { children }), $[12] = children, $[13] = t2), children = t2;
	}
	let t2;
	$[14] === align ? t2 = $[15] : (t2 = _getArrayProp(align), $[14] = align, $[15] = t2);
	let t3;
	$[16] === size ? t3 = $[17] : (t3 = _getArrayProp(size), $[16] = size, $[17] = t3);
	let t4;
	return $[18] !== accent || $[19] !== children || $[20] !== muted || $[21] !== ref || $[22] !== restProps || $[23] !== t2 || $[24] !== t3 || $[25] !== weight ? (t4 = /* @__PURE__ */ jsx(StyledLabel, {
		"data-ui": "Label",
		...restProps,
		$accent: accent,
		$align: t2,
		$muted: muted,
		$size: t3,
		$weight: weight,
		ref,
		children
	}), $[18] = accent, $[19] = children, $[20] = muted, $[21] = ref, $[22] = restProps, $[23] = t2, $[24] = t3, $[25] = weight, $[26] = t4) : t4 = $[26], t4;
}
/**
* Typographic labels.
*
* @public
*/
const Label = LabelComponent, avatarStyle = {
	root: avatarRootStyle,
	arrow: avatarArrowStyle,
	bgStroke: avatarBgStrokeStyle,
	stroke: avatarStrokeStyle,
	initials: avatarInitialsStyle,
	image: avatarImageStyle
};
function avatarArrowStyle() {
	return {
		position: "absolute",
		boxSizing: "border-box",
		zIndex: "0",
		opacity: "0",
		transition: "all 0.2s linear",
		transform: "rotate(-90deg) translate3d(0, 6px, 0)",
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		"& > svg": {
			width: "11px",
			height: "7px",
			position: "absolute",
			top: "-5px",
			left: "50%",
			transform: "translateX(-6px)",
			"&:not([hidden])": { display: "block" }
		},
		"[data-arrow-position='inside'] > &": {
			transform: "rotate(-90deg) translate3d(0, 6px, 0)",
			opacity: "0"
		},
		"[data-arrow-position='top'] > &": {
			opacity: "1",
			transform: "rotate(0deg)"
		},
		"[data-arrow-position='bottom'] > &": {
			opacity: "1",
			transform: "rotate(-180deg)"
		}
	};
}
function avatarRootStyle(props) {
	let { $color } = props, { avatar } = getTheme_v2(props.theme);
	return {
		"--avatar-bg-color": `var(--card-avatar-${$color}-bg-color)`,
		"--avatar-fg-color": `var(--card-avatar-${$color}-fg-color)`,
		backgroundColor: "var(--avatar-bg-color)",
		position: "relative",
		boxSizing: "border-box",
		userSelect: "none",
		boxShadow: "0 0 0 1px var(--card-bg-color)",
		"&[data-status=\"inactive\"]": { opacity: "0.5" },
		"&>svg": { "&:not([hidden])": { display: "block" } },
		"&[data-as=\"button\"]": {
			WebkitFontSmoothing: "inherit",
			appearance: "none",
			margin: 0,
			padding: 0,
			border: 0,
			font: "inherit",
			color: "inherit",
			outline: "none",
			"&:focus": { boxShadow: focusRingStyle({ focusRing: avatar.focusRing }) },
			"&:focus:not(:focus-visible)": { boxShadow: "none" }
		}
	};
}
function responsiveAvatarSizeStyle(props) {
	let { avatar, media } = getTheme_v2(props.theme);
	return _responsive(media, props.$size, (size) => {
		let avatarSize = avatar.sizes[size] || avatar.sizes[0];
		return {
			width: rem(avatarSize.size),
			height: rem(avatarSize.size),
			borderRadius: rem(avatarSize.size / 2),
			"&>svg": {
				width: rem(avatarSize.size),
				height: rem(avatarSize.size),
				borderRadius: rem(avatarSize.size / 2)
			}
		};
	});
}
function avatarImageStyle() {
	return { position: "relative" };
}
function avatarInitialsStyle() {
	return {
		width: "100%",
		height: "100%",
		color: "var(--avatar-fg-color)",
		alignItems: "center",
		justifyContent: "center",
		textTransform: "uppercase",
		textAlign: "center",
		borderRadius: "50%",
		"&:not([hidden])": { display: "flex" }
	};
}
function avatarBgStrokeStyle() {
	return {
		strokeWidth: "4px",
		stroke: "var(--card-bg-color)"
	};
}
function avatarStrokeStyle() {
	return {
		strokeWidth: "2px",
		stroke: "var(--avatar-bg-color)",
		"[data-status=\"editing\"] &": {
			strokeDasharray: "2 4",
			strokeLinecap: "round"
		}
	};
}
const StyledAvatar = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledAvatar",
	componentId: "sc-70v725-0"
})(responsiveAvatarSizeStyle, avatarStyle.root), Arrow$1 = /* @__PURE__ */ styled.div.withConfig({
	displayName: "Arrow",
	componentId: "sc-70v725-1"
})(avatarStyle.arrow), BgStroke = /* @__PURE__ */ styled.ellipse.withConfig({
	displayName: "BgStroke",
	componentId: "sc-70v725-2"
})(avatarStyle.bgStroke), Stroke = /* @__PURE__ */ styled.ellipse.withConfig({
	displayName: "Stroke",
	componentId: "sc-70v725-3"
})(avatarStyle.stroke), Initials = /* @__PURE__ */ styled.div.withConfig({
	displayName: "Initials",
	componentId: "sc-70v725-4"
})(avatarStyle.initials), InitialsLabel = /* @__PURE__ */ styled(Label).withConfig({
	displayName: "InitialsLabel",
	componentId: "sc-70v725-5"
})({ color: "inherit" }), AvatarImage = /* @__PURE__ */ styled.svg.withConfig({
	displayName: "AvatarImage",
	componentId: "sc-70v725-6"
})(avatarStyle.image);
function AvatarComponent(props) {
	let $ = c(47), __unstable_hideInnerStroke, animateArrowFrom, arrowPositionProp, asProp, initials, onImageLoadError, ref, restProps, src, t0, t1, t2, title;
	$[0] === props ? (__unstable_hideInnerStroke = $[1], animateArrowFrom = $[2], arrowPositionProp = $[3], asProp = $[4], initials = $[5], onImageLoadError = $[6], ref = $[7], restProps = $[8], src = $[9], t0 = $[10], t1 = $[11], t2 = $[12], title = $[13]) : ({__unstable_hideInnerStroke, as: asProp, color: t0, src, title, initials, onImageLoadError, arrowPosition: arrowPositionProp, animateArrowFrom, ref, status: t1, size: t2, ...restProps} = props, $[0] = props, $[1] = __unstable_hideInnerStroke, $[2] = animateArrowFrom, $[3] = arrowPositionProp, $[4] = asProp, $[5] = initials, $[6] = onImageLoadError, $[7] = ref, $[8] = restProps, $[9] = src, $[10] = t0, $[11] = t1, $[12] = t2, $[13] = title);
	let color = t0 === void 0 ? "gray" : t0, status = t1 === void 0 ? "online" : t1, sizeProp = t2 === void 0 ? 1 : t2, { avatar } = useTheme_v2(), as = ReactIs.isValidElementType(asProp) ? asProp : "div", size = _getArrayProp(sizeProp), _sizeRem = (avatar.sizes[size[0]] || avatar.sizes[0]).size, _radius = _sizeRem / 2, elementId = useId(), [arrowPosition, setArrowPosition] = useState(animateArrowFrom || arrowPositionProp || "inside"), [imageFailed, setImageFailed] = useState(!1), imageId = `avatar-image-${elementId}`, t3, t4;
	$[14] !== arrowPosition || $[15] !== arrowPositionProp ? (t3 = () => {
		if (arrowPosition === arrowPositionProp) return;
		let raf = requestAnimationFrame(() => setArrowPosition(arrowPositionProp));
		return () => cancelAnimationFrame(raf);
	}, t4 = [arrowPosition, arrowPositionProp], $[14] = arrowPosition, $[15] = arrowPositionProp, $[16] = t3, $[17] = t4) : (t3 = $[16], t4 = $[17]), useEffect(t3, t4);
	let t5, t6;
	$[18] === src ? (t5 = $[19], t6 = $[20]) : (t5 = () => {
		src && setImageFailed(!1);
	}, t6 = [src], $[18] = src, $[19] = t5, $[20] = t6), useEffect(t5, t6);
	let t7;
	$[21] === onImageLoadError ? t7 = $[22] : (t7 = () => {
		setImageFailed(!0), onImageLoadError && onImageLoadError(/* @__PURE__ */ Error("Avatar: the image failed to load"));
	}, $[21] = onImageLoadError, $[22] = t7);
	let handleImageError = t7, T0 = StyledAvatar, t8 = typeof as == "string" ? as : void 0, t10;
	$[23] === color ? t10 = $[24] : (t10 = /* @__PURE__ */ jsx(Arrow$1, { children: /* @__PURE__ */ jsx("svg", {
		width: "11",
		height: "7",
		viewBox: "0 0 11 7",
		fill: "none",
		children: /* @__PURE__ */ jsx("path", {
			d: "M6.67948 1.50115L11 7L0 7L4.32052 1.50115C4.92109 0.736796 6.07891 0.736795 6.67948 1.50115Z",
			fill: color
		})
	}) }), $[23] = color, $[24] = t10);
	let t11;
	$[25] !== __unstable_hideInnerStroke || $[26] !== _radius || $[27] !== _sizeRem || $[28] !== handleImageError || $[29] !== imageFailed || $[30] !== imageId || $[31] !== src ? (t11 = !imageFailed && src && /* @__PURE__ */ jsxs(AvatarImage, {
		viewBox: `0 0 ${_sizeRem} ${_sizeRem}`,
		fill: "none",
		children: [
			/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("pattern", {
				id: imageId,
				patternContentUnits: "objectBoundingBox",
				width: "1",
				height: "1",
				children: /* @__PURE__ */ jsx("image", {
					href: src,
					width: "1",
					height: "1",
					onError: handleImageError
				})
			}) }),
			/* @__PURE__ */ jsx("circle", {
				cx: _radius,
				cy: _radius,
				r: _radius,
				fill: `url(#${imageId})`
			}),
			!__unstable_hideInnerStroke && /* @__PURE__ */ jsx(BgStroke, {
				cx: _radius,
				cy: _radius,
				rx: _radius,
				ry: _radius,
				vectorEffect: "non-scaling-stroke"
			}),
			/* @__PURE__ */ jsx(Stroke, {
				cx: _radius,
				cy: _radius,
				rx: _radius,
				ry: _radius,
				vectorEffect: "non-scaling-stroke"
			})
		]
	}), $[25] = __unstable_hideInnerStroke, $[26] = _radius, $[27] = _sizeRem, $[28] = handleImageError, $[29] = imageFailed, $[30] = imageId, $[31] = src, $[32] = t11) : t11 = $[32];
	let t12 = (imageFailed || !src) && initials && /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Initials, { children: /* @__PURE__ */ jsx(InitialsLabel, {
		forwardedAs: "span",
		size: size.map(_temp$2),
		weight: "medium",
		children: initials
	}) }) }), t13;
	return $[33] !== T0 || $[34] !== arrowPosition || $[35] !== as || $[36] !== color || $[37] !== ref || $[38] !== restProps || $[39] !== size || $[40] !== status || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t8 || $[45] !== title ? (t13 = /* @__PURE__ */ jsxs(T0, {
		as,
		"data-as": t8,
		"data-ui": "Avatar",
		...restProps,
		$color: color,
		$size: size,
		"aria-label": title,
		"data-arrow-position": arrowPosition,
		"data-status": status,
		ref,
		title,
		children: [
			t10,
			t11,
			t12
		]
	}), $[33] = T0, $[34] = arrowPosition, $[35] = as, $[36] = color, $[37] = ref, $[38] = restProps, $[39] = size, $[40] = status, $[41] = t10, $[42] = t11, $[43] = t12, $[44] = t8, $[45] = title, $[46] = t13) : t13 = $[46], t13;
}
/**
* Avatars are used to represent people and other agents (e.g. bots).
*
* @public
*/
function _temp$2(s) {
	return s === 1 ? 1 : s === 2 ? 3 : s === 3 ? 5 : 0;
}
const Avatar = AvatarComponent;
function _responsiveAvatarCounterSizeStyle(props) {
	let { avatar, media } = getTheme_v2(props.theme);
	return _responsive(media, props.$size, (size) => {
		let avatarSize = avatar.sizes[size];
		return avatarSize ? {
			borderRadius: rem(avatarSize.size / 2),
			minWidth: rem(avatarSize.size),
			height: rem(avatarSize.size)
		} : EMPTY_RECORD;
	});
}
function _avatarCounterBaseStyle(props) {
	let { space } = getTheme_v2(props.theme);
	return css`align-items:center;justify-content:center;box-sizing:border-box;user-select:none;color:inherit;color:var(--card-fg-color);background:var(--card-bg-color);box-shadow:0 0 0 1px var(--card-bg-color),inset 0 0 0 1px var(--card-hairline-hard-color);padding:0 ${rem(space[2])};&:not([hidden]){display:flex;}`;
}
const StyledAvatarCounter = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledAvatarCounter",
	componentId: "sc-tzf8eq-0"
})(_responsiveAvatarCounterSizeStyle, _avatarCounterBaseStyle);
/**
* @public
*/
function AvatarCounter(props) {
	let $ = c(20), { count, ref, size: t0 } = props, sizeProp = t0 === void 0 ? 1 : t0, T0, T1, t1, t2, t3, t4, t5;
	if ($[0] !== ref || $[1] !== sizeProp) {
		let size = _getArrayProp(sizeProp);
		T1 = StyledAvatarCounter, t3 = size, t4 = "AvatarCounter", t5 = ref, T0 = Label, t1 = "span", t2 = size.map(_temp$1), $[0] = ref, $[1] = sizeProp, $[2] = T0, $[3] = T1, $[4] = t1, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5;
	} else T0 = $[2], T1 = $[3], t1 = $[4], t2 = $[5], t3 = $[6], t4 = $[7], t5 = $[8];
	let t6;
	$[9] !== T0 || $[10] !== count || $[11] !== t1 || $[12] !== t2 ? (t6 = /* @__PURE__ */ jsx(T0, {
		as: t1,
		size: t2,
		weight: "medium",
		children: count
	}), $[9] = T0, $[10] = count, $[11] = t1, $[12] = t2, $[13] = t6) : t6 = $[13];
	let t7;
	return $[14] !== T1 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(T1, {
		$size: t3,
		"data-ui": t4,
		ref: t5,
		children: t6
	}), $[14] = T1, $[15] = t3, $[16] = t4, $[17] = t5, $[18] = t6, $[19] = t7) : t7 = $[19], t7;
}
function _temp$1(s) {
	return s === 1 ? 1 : s === 2 ? 3 : s === 3 ? 5 : 0;
}
const BASE_STYLES = css`white-space:nowrap;& > div{vertical-align:top;&:not([hidden]){display:inline-block;}}`;
function avatarStackStyle() {
	return BASE_STYLES;
}
function responsiveAvatarStackSizeStyle(props) {
	let { avatar, media } = getTheme_v2(props.theme);
	return _responsive(media, props.$size, (size) => {
		let avatarSize = avatar.sizes[size];
		return avatarSize ? { "& > div + div": { marginLeft: rem(avatarSize.distance) } } : EMPTY_RECORD;
	});
}
const StyledAvatarStack = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledAvatarStack",
	componentId: "sc-lhp7nq-0"
})(responsiveAvatarStackSizeStyle, avatarStackStyle);
/**
* @public
*/
function AvatarStack(props) {
	let $ = c(39), childrenProp, ref, restProps, t0, t1;
	$[0] === props ? (childrenProp = $[1], ref = $[2], restProps = $[3], t0 = $[4], t1 = $[5]) : ({children: childrenProp, maxLength: t0, ref, size: t1, ...restProps} = props, $[0] = props, $[1] = childrenProp, $[2] = ref, $[3] = restProps, $[4] = t0, $[5] = t1);
	let maxLengthProp = t0 === void 0 ? 4 : t0, sizeProp = t1 === void 0 ? 1 : t1, T0, t2, t3, t4, t5, t6, t7, t8;
	if ($[6] !== childrenProp || $[7] !== maxLengthProp || $[8] !== ref || $[9] !== restProps || $[10] !== sizeProp) {
		let children = Children.toArray(childrenProp).filter(isValidElement), maxLength = Math.max(maxLengthProp, 0), t9;
		$[19] === sizeProp ? t9 = $[20] : (t9 = _getArrayProp(sizeProp), $[19] = sizeProp, $[20] = t9);
		let size = t9, len = children.length, extraCount = len - (maxLength - 1), visibleChildren = extraCount > 1 ? children.slice(extraCount, len) : children;
		T0 = StyledAvatarStack, t2 = "AvatarStack", t3 = restProps, t4 = ref, t5 = size, $[21] !== len || $[22] !== size ? (t6 = len === 0 && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(AvatarCounter, {
			count: len,
			size
		}) }), $[21] = len, $[22] = size, $[23] = t6) : t6 = $[23], $[24] !== extraCount || $[25] !== len || $[26] !== size ? (t7 = len !== 0 && extraCount > 1 && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(AvatarCounter, {
			count: extraCount,
			size
		}) }), $[24] = extraCount, $[25] = len, $[26] = size, $[27] = t7) : t7 = $[27];
		let t10;
		$[28] === size ? t10 = $[29] : (t10 = (child, childIndex) => /* @__PURE__ */ jsx("div", { children: cloneElement(child, { size }) }, String(childIndex)), $[28] = size, $[29] = t10), t8 = visibleChildren.map(t10), $[6] = childrenProp, $[7] = maxLengthProp, $[8] = ref, $[9] = restProps, $[10] = sizeProp, $[11] = T0, $[12] = t2, $[13] = t3, $[14] = t4, $[15] = t5, $[16] = t6, $[17] = t7, $[18] = t8;
	} else T0 = $[11], t2 = $[12], t3 = $[13], t4 = $[14], t5 = $[15], t6 = $[16], t7 = $[17], t8 = $[18];
	let t9;
	return $[30] !== T0 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 ? (t9 = /* @__PURE__ */ jsxs(T0, {
		"data-ui": t2,
		...t3,
		ref: t4,
		$size: t5,
		children: [
			t6,
			t7,
			t8
		]
	}), $[30] = T0, $[31] = t2, $[32] = t3, $[33] = t4, $[34] = t5, $[35] = t6, $[36] = t7, $[37] = t8, $[38] = t9) : t9 = $[38], t9;
}
function badgeStyle(props) {
	let { $tone } = props;
	return {
		"--card-bg-color": `var(--card-badge-${$tone}-bg-color)`,
		"--card-fg-color": `var(--card-badge-${$tone}-fg-color)`,
		backgroundColor: "var(--card-bg-color)",
		cursor: "default",
		"&:not([hidden])": {
			display: "inline-block",
			verticalAlign: "top"
		}
	};
}
const StyledBadge = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledBadge",
	componentId: "sc-vbjdyi-0"
})(responsiveRadiusStyle, badgeStyle), Badge = function Badge(props) {
	let $ = c(22), children, ref, restProps, t0, t1, t2, t3;
	$[0] === props ? (children = $[1], ref = $[2], restProps = $[3], t0 = $[4], t1 = $[5], t2 = $[6], t3 = $[7]) : ({children, fontSize: t0, padding: t1, radius: t2, ref, tone: t3, ...restProps} = props, $[0] = props, $[1] = children, $[2] = ref, $[3] = restProps, $[4] = t0, $[5] = t1, $[6] = t2, $[7] = t3);
	let fontSize = t0 === void 0 ? 1 : t0, padding = t1 === void 0 ? 1 : t1, radius = t2 === void 0 ? "full" : t2, tone = t3 === void 0 ? "default" : t3, t4;
	$[8] === radius ? t4 = $[9] : (t4 = _getArrayProp(radius), $[8] = radius, $[9] = t4);
	let t5;
	$[10] === padding ? t5 = $[11] : (t5 = _getArrayProp(padding), $[10] = padding, $[11] = t5);
	let t6;
	$[12] !== children || $[13] !== fontSize ? (t6 = /* @__PURE__ */ jsx(Text, {
		size: fontSize,
		children
	}), $[12] = children, $[13] = fontSize, $[14] = t6) : t6 = $[14];
	let t7;
	return $[15] !== ref || $[16] !== restProps || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== tone ? (t7 = /* @__PURE__ */ jsx(StyledBadge, {
		"data-ui": "Badge",
		...restProps,
		$tone: tone,
		$radius: t4,
		padding: t5,
		ref,
		children: t6
	}), $[15] = ref, $[16] = restProps, $[17] = t4, $[18] = t5, $[19] = t6, $[20] = tone, $[21] = t7) : t7 = $[21], t7;
};
function checkboxBaseStyles() {
	return css`position:relative;display:inline-block;`;
}
function inputElementStyles(props) {
	let { color, input, radius } = getTheme_v2(props.theme), { focusRing } = input.checkbox;
	return css`position:absolute;top:0;left:0;width:100%;height:100%;outline:none;opacity:0;z-index:1;padding:0;margin:0;& + span{position:relative;display:block;height:${rem(input.checkbox.size)};width:${rem(input.checkbox.size)};box-sizing:border-box;box-shadow:${focusRingBorderStyle({
		color: color.input.default.enabled.border,
		width: input.border.width
	})};border-radius:${rem(radius[2])};line-height:1;background-color:${color.input.default.enabled.bg};& > svg{display:block;position:absolute;opacity:0;height:100%;width:100%;& > path{vector-effect:non-scaling-stroke;stroke-width:1.5px !important;}}}&:checked + span{background:${color.input.default.enabled.fg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.enabled.fg,
		width: input.border.width
	})};color:${color.input.default.enabled.bg};}&:not(:disabled):focus:focus-visible + span{box-shadow:${focusRingStyle({ focusRing })};}&:not(:disabled):focus:focus-visible&:checked + span{box-shadow:${focusRingStyle({ focusRing: {
		width: 1,
		offset: 1
	} })};}&[data-error] + span{background-color:${color.input.invalid.enabled.border};box-shadow:${focusRingBorderStyle({
		width: input.border.width,
		color: color.input.invalid.enabled.muted.bg
	})};color:${color.input.default.disabled.fg};}&[data-error]&:checked + span{background-color:${color.input.invalid.enabled.muted.bg};color:${color.input.default.enabled.bg};}&[data-error]&:checked&:not(:disabled):focus:focus-visible + span{box-shadow:${focusRingStyle({
		border: {
			width: input.border.width,
			color: color.input.invalid.readOnly.muted.bg
		},
		focusRing: {
			width: 1,
			offset: 1
		}
	})};}&:disabled + span{background-color:${color.input.default.disabled.bg};box-shadow:${focusRingBorderStyle({
		width: input.border.width,
		color: color.input.default.disabled.border
	})};color:${color.input.default.disabled.fg};}&:disabled&:checked + span{background-color:${color.input.default.disabled.muted.bg};}&[data-read-only] + span{background-color:${color.input.default.readOnly.bg};box-shadow:${focusRingBorderStyle({
		width: input.border.width,
		color: color.input.default.readOnly.border
	})};color:${color.input.default.readOnly.fg};}&[data-read-only]&:checked + span{background-color:${color.input.default.readOnly.muted.bg};}&:checked + span > svg:first-child{opacity:1;}&:indeterminate + span > svg:last-child{opacity:1;}`;
}
const StyledCheckbox = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledCheckbox",
	componentId: "sc-zlqryb-0"
})(checkboxBaseStyles), Input$4 = /* @__PURE__ */ styled.input.withConfig({
	displayName: "Input",
	componentId: "sc-zlqryb-1"
})(inputElementStyles);
/**
* Checkboxes allow the user to select one or more items from a set.
*
* @public
*/
function Checkbox(props) {
	let $ = c(26), checked, className, customValidity, disabled, forwardedRef, indeterminate, readOnly, restProps, style;
	$[0] === props ? (checked = $[1], className = $[2], customValidity = $[3], disabled = $[4], forwardedRef = $[5], indeterminate = $[6], readOnly = $[7], restProps = $[8], style = $[9]) : ({checked, className, disabled, indeterminate, customValidity, readOnly, ref: forwardedRef, style, ...restProps} = props, $[0] = props, $[1] = checked, $[2] = className, $[3] = customValidity, $[4] = disabled, $[5] = forwardedRef, $[6] = indeterminate, $[7] = readOnly, $[8] = restProps, $[9] = style);
	let ref = useRef(null), t0;
	$[10] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => ref.current, $[10] = t0) : t0 = $[10], useImperativeHandle(forwardedRef, t0);
	let t1, t2;
	$[11] === indeterminate ? (t1 = $[12], t2 = $[13]) : (t1 = () => {
		ref.current && (ref.current.indeterminate = indeterminate || !1);
	}, t2 = [indeterminate], $[11] = indeterminate, $[12] = t1, $[13] = t2), useEffect(t1, t2), useCustomValidity(ref, customValidity);
	let t3 = !disabled && readOnly ? "" : void 0, t4 = customValidity ? "" : void 0, t5 = disabled || readOnly, t6;
	$[14] !== checked || $[15] !== readOnly || $[16] !== restProps || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsx(Input$4, {
		"data-read-only": t3,
		"data-error": t4,
		...restProps,
		checked,
		disabled: t5,
		type: "checkbox",
		readOnly,
		ref
	}), $[14] = checked, $[15] = readOnly, $[16] = restProps, $[17] = t3, $[18] = t4, $[19] = t5, $[20] = t6) : t6 = $[20];
	let t7;
	$[21] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx(CheckmarkIcon, {}), /* @__PURE__ */ jsx(RemoveIcon, {})] }), $[21] = t7) : t7 = $[21];
	let t8;
	return $[22] !== className || $[23] !== style || $[24] !== t6 ? (t8 = /* @__PURE__ */ jsxs(StyledCheckbox, {
		className,
		"data-ui": "Checkbox",
		style,
		children: [t6, t7]
	}), $[22] = className, $[23] = style, $[24] = t6, $[25] = t8) : t8 = $[25], t8;
}
/**
* Get responsive CSS for the `heading` font style.
* @internal
*/
function responsiveHeadingFont(props) {
	return responsiveFont("heading", props);
}
function headingBaseStyle(props) {
	let { $accent, $muted } = props, { font } = getTheme_v2(props.theme);
	return css`${$accent && css`color:var(--card-accent-fg-color);`} ${$muted && css`color:var(--card-muted-fg-color);`} & code{font-family:${font.code.family};border-radius:1px;}& a{text-decoration:none;border-radius:1px;color:var(--card-link-color);outline:none;@media (hover:hover){&:hover{text-decoration:underline;}}&:focus{box-shadow:0 0 0 1px var(--card-bg-color),0 0 0 3px var(--card-focus-ring-color);}&:focus:not(:focus-visible){box-shadow:none;}}& strong{font-weight:${font.heading.weights.bold};}& svg{display:inline;max-width:unset;}& [data-sanity-icon]{vertical-align:baseline;}`;
}
const StyledHeading = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledHeading",
	componentId: "sc-qdvbbh-0"
})(headingBaseStyle, responsiveTextAlignStyle, responsiveHeadingFont);
function HeadingComponent(props) {
	let $ = c(27), align, childrenProp, ref, restProps, t0, t1, t2, textOverflow, weight;
	$[0] === props ? (align = $[1], childrenProp = $[2], ref = $[3], restProps = $[4], t0 = $[5], t1 = $[6], t2 = $[7], textOverflow = $[8], weight = $[9]) : ({accent: t0, align, children: childrenProp, muted: t1, ref, size: t2, textOverflow, weight, ...restProps} = props, $[0] = props, $[1] = align, $[2] = childrenProp, $[3] = ref, $[4] = restProps, $[5] = t0, $[6] = t1, $[7] = t2, $[8] = textOverflow, $[9] = weight);
	let accent = t0 !== void 0 && t0, muted = t1 !== void 0 && t1, size = t2 === void 0 ? 2 : t2, children = childrenProp;
	if (textOverflow === "ellipsis") {
		let t3;
		$[10] === children ? t3 = $[11] : (t3 = /* @__PURE__ */ jsx(SpanWithTextOverflow, { children }), $[10] = children, $[11] = t3), children = t3;
	}
	let t3;
	$[12] === align ? t3 = $[13] : (t3 = _getArrayProp(align), $[12] = align, $[13] = t3);
	let t4;
	$[14] === size ? t4 = $[15] : (t4 = _getArrayProp(size), $[14] = size, $[15] = t4);
	let t5;
	$[16] === children ? t5 = $[17] : (t5 = /* @__PURE__ */ jsx("span", { children }), $[16] = children, $[17] = t5);
	let t6;
	return $[18] !== accent || $[19] !== muted || $[20] !== ref || $[21] !== restProps || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== weight ? (t6 = /* @__PURE__ */ jsx(StyledHeading, {
		"data-ui": "Heading",
		...restProps,
		$accent: accent,
		$align: t3,
		$muted: muted,
		$size: t4,
		$weight: weight,
		ref,
		children: t5
	}), $[18] = accent, $[19] = muted, $[20] = ref, $[21] = restProps, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = weight, $[26] = t6) : t6 = $[26], t6;
}
/**
* Typographic headings.
*
* @public
*/
const Heading = HeadingComponent;
function radioBaseStyle() {
	return css`position:relative;&:not([hidden]){display:inline-block;}&[data-read-only]{outline:1px solid red;}`;
}
function inputElementStyle(props) {
	let { color, input } = getTheme_v2(props.theme), dist = (input.radio.size - input.radio.markSize) / 2;
	return css`appearance:none;position:absolute;top:0;left:0;opacity:0;height:100%;width:100%;outline:none;z-index:1;padding:0;margin:0;border-radius:${rem(input.radio.size / 2)};border:none;& + span{display:block;position:relative;height:${rem(input.radio.size)};width:${rem(input.radio.size)};border-radius:${rem(input.radio.size / 2)};background:${color.input.default.enabled.bg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.enabled.border,
		width: input.border.width
	})};&::after{content:'';position:absolute;top:${rem(dist)};left:${rem(dist)};height:${rem(input.radio.markSize)};width:${rem(input.radio.markSize)};border-radius:${rem(input.radio.markSize / 2)};background:${color.input.default.enabled.fg};opacity:0;}}&:not(:disabled):focus + span{box-shadow:${focusRingStyle({
		border: {
			width: input.border.width,
			color: color.input.default.enabled.border
		},
		focusRing: input.radio.focusRing
	})};}&:not(:disabled):focus:not(:focus-visible) + span{box-shadow:${focusRingBorderStyle({
		color: color.input.default.enabled.border,
		width: input.border.width
	})};}&:checked + span::after{opacity:1;}&[data-error] + span{background-color:${color.input.invalid.enabled.border};box-shadow:${focusRingBorderStyle({
		width: input.border.width,
		color: color.input.invalid.enabled.muted.bg
	})};&::after{background:${color.input.invalid.enabled.muted.bg};}}&[data-read-only] + span{box-shadow:0 0 0 1px ${color.input.default.readOnly.border};background:${color.input.default.readOnly.bg};&::after{background:${color.input.default.readOnly.border};}}&:not([data-read-only]):disabled + span{box-shadow:0 0 0 1px ${color.input.default.disabled.border};background:${color.input.default.disabled.bg};&::after{background:${color.input.default.disabled.border};}}`;
}
const StyledRadio = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledRadio",
	componentId: "sc-q0nfb5-0"
})(radioBaseStyle), Input$3 = /* @__PURE__ */ styled.input.withConfig({
	displayName: "Input",
	componentId: "sc-q0nfb5-1"
})(inputElementStyle);
/**
* The `Radio` component allows the user to select one option from a set.
*
* @public
*/
function Radio(props) {
	let $ = c(20), className, customValidity, disabled, forwardedRef, readOnly, restProps, style;
	$[0] === props ? (className = $[1], customValidity = $[2], disabled = $[3], forwardedRef = $[4], readOnly = $[5], restProps = $[6], style = $[7]) : ({className, disabled, style, customValidity, readOnly, ref: forwardedRef, ...restProps} = props, $[0] = props, $[1] = className, $[2] = customValidity, $[3] = disabled, $[4] = forwardedRef, $[5] = readOnly, $[6] = restProps, $[7] = style);
	let ref = useRef(null), t0;
	$[8] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => ref.current, $[8] = t0) : t0 = $[8], useImperativeHandle(forwardedRef, t0), useCustomValidity(ref, customValidity);
	let t1 = !disabled && readOnly ? "" : void 0, t2 = customValidity ? "" : void 0, t3 = disabled || readOnly, t4;
	$[9] !== readOnly || $[10] !== restProps || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Input$3, {
		"data-read-only": t1,
		"data-error": t2,
		...restProps,
		disabled: t3,
		readOnly,
		ref,
		type: "radio"
	}), $[9] = readOnly, $[10] = restProps, $[11] = t1, $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14];
	let t5;
	$[15] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx("span", {}), $[15] = t5) : t5 = $[15];
	let t6;
	return $[16] !== className || $[17] !== style || $[18] !== t4 ? (t6 = /* @__PURE__ */ jsxs(StyledRadio, {
		className,
		"data-ui": "Radio",
		style,
		children: [t4, t5]
	}), $[16] = className, $[17] = style, $[18] = t4, $[19] = t6) : t6 = $[19], t6;
}
function rootStyle() {
	return css`position:relative;width:-moz-available;width:-webkit-fill-available;width:stretch;&:not([hidden]){display:inline-block;}`;
}
function inputBaseStyle(props) {
	let { font } = getTheme_v2(props.theme);
	return css`-webkit-font-smoothing:antialiased;appearance:none;border:0;font-family:${font.text.family};color:inherit;width:100%;outline:none;margin:0;&:disabled{opacity:1;}`;
}
function inputColorStyle(props) {
	let { color, input } = getTheme_v2(props.theme);
	return css`background-color:${color.input.default.enabled.bg};color:${color.input.default.enabled.fg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.enabled.border,
		width: input.border.width
	})};@media (hover:hover){&:not(:disabled):hover{background-color:${color.input.default.hovered.bg};color:${color.input.default.hovered.fg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.hovered.border,
		width: input.border.width
	})};}}&:not(:disabled):focus{box-shadow:${focusRingStyle({
		border: {
			width: input.border.width,
			color: color.input.default.enabled.border
		},
		focusRing: input.select.focusRing
	})};}&[data-read-only]{background-color:${color.input.default.readOnly.bg};color:${color.input.default.readOnly.fg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.readOnly.border,
		width: input.border.width
	})};}&:not([data-read-only]):disabled{background-color:${color.input.default.disabled.bg};color:${color.input.default.disabled.fg};box-shadow:${focusRingBorderStyle({
		color: color.input.default.disabled.border,
		width: input.border.width
	})};}`;
}
function textSize(size) {
	return {
		fontSize: rem(size.fontSize),
		lineHeight: `${rem(size.lineHeight)}`
	};
}
function inputTextSizeStyle(props) {
	let { $fontSize } = props, { font, media } = getTheme_v2(props.theme);
	return _responsive(media, $fontSize, (sizeIndex) => textSize(font.text.sizes[sizeIndex] || font.text.sizes[2]));
}
function inputStyle() {
	return [
		responsiveRadiusStyle,
		inputBaseStyle,
		inputColorStyle,
		inputTextSizeStyle,
		responsiveInputPaddingIconRightStyle
	];
}
function iconBoxStyle(props) {
	let { color } = getTheme_v2(props.theme);
	return css`pointer-events:none;position:absolute;top:0;right:0;--card-fg-color:${color.input.default.enabled.fg};@media (hover:hover){select:not(disabled):not(:read-only):hover + &&{--card-fg-color:${color.input.default.hovered.fg};}}select:disabled + &&{--card-fg-color:${color.input.default.disabled.fg};}select[data-read-only] + &&{--card-fg-color:${color.input.default.readOnly.fg};}`;
}
const selectStyle = {
	root: rootStyle,
	input: inputStyle,
	iconBox: iconBoxStyle
}, StyledSelect = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledSelect",
	componentId: "sc-y93hdm-0"
})(selectStyle.root), Input$2 = /* @__PURE__ */ styled.select.withConfig({
	displayName: "Input",
	componentId: "sc-y93hdm-1"
})(selectStyle.input), IconBox = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "IconBox",
	componentId: "sc-y93hdm-2"
})(selectStyle.iconBox);
/**
* The `Select` component provides control of options.
*
* @public
*/
function Select(props) {
	let $ = c(38), children, customValidity, disabled, forwardedRef, readOnly, restProps, t0, t1, t2, t3;
	$[0] === props ? (children = $[1], customValidity = $[2], disabled = $[3], forwardedRef = $[4], readOnly = $[5], restProps = $[6], t0 = $[7], t1 = $[8], t2 = $[9], t3 = $[10]) : ({children, customValidity, disabled, fontSize: t0, gap: t1, padding: t2, radius: t3, readOnly, ref: forwardedRef, ...restProps} = props, $[0] = props, $[1] = children, $[2] = customValidity, $[3] = disabled, $[4] = forwardedRef, $[5] = readOnly, $[6] = restProps, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = t3);
	let fontSize = t0 === void 0 ? 2 : t0, gap = t1 === void 0 ? 3 : t1, padding = t2 === void 0 ? 3 : t2, radius = t3 === void 0 ? 2 : t3, ref = useRef(null), t4;
	$[11] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => ref.current, $[11] = t4) : t4 = $[11], useImperativeHandle(forwardedRef, t4), useCustomValidity(ref, customValidity);
	let t5 = !disabled && readOnly ? "" : void 0, t6;
	$[12] === fontSize ? t6 = $[13] : (t6 = _getArrayProp(fontSize), $[12] = fontSize, $[13] = t6);
	let t7;
	$[14] === padding ? t7 = $[15] : (t7 = _getArrayProp(padding), $[14] = padding, $[15] = t7);
	let t8;
	$[16] === radius ? t8 = $[17] : (t8 = _getArrayProp(radius), $[16] = radius, $[17] = t8);
	let t9;
	$[18] === gap ? t9 = $[19] : (t9 = _getArrayProp(gap), $[18] = gap, $[19] = t9);
	let t10 = disabled || readOnly, t11;
	$[20] !== children || $[21] !== restProps || $[22] !== t10 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9 ? (t11 = /* @__PURE__ */ jsx(Input$2, {
		"data-read-only": t5,
		"data-ui": "Select",
		...restProps,
		$fontSize: t6,
		$padding: t7,
		$radius: t8,
		$space: t9,
		disabled: t10,
		ref,
		children
	}), $[20] = children, $[21] = restProps, $[22] = t10, $[23] = t5, $[24] = t6, $[25] = t7, $[26] = t8, $[27] = t9, $[28] = t11) : t11 = $[28];
	let t12;
	$[29] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(ChevronDownIcon, {}), $[29] = t12) : t12 = $[29];
	let t13;
	$[30] === fontSize ? t13 = $[31] : (t13 = /* @__PURE__ */ jsx(Text, {
		size: fontSize,
		children: t12
	}), $[30] = fontSize, $[31] = t13);
	let t14;
	$[32] !== padding || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsx(IconBox, {
		padding,
		children: t13
	}), $[32] = padding, $[33] = t13, $[34] = t14) : t14 = $[34];
	let t15;
	return $[35] !== t11 || $[36] !== t14 ? (t15 = /* @__PURE__ */ jsxs(StyledSelect, {
		"data-ui": "Select",
		children: [t11, t14]
	}), $[35] = t11, $[36] = t14, $[37] = t15) : t15 = $[37], t15;
}
function switchBaseStyles() {
	return css`position:relative;&:not([hidden]){display:inline-block;}`;
}
function switchInputStyles() {
	return css`position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;height:100%;width:100%;outline:none;padding:0;margin:0;z-index:1;`;
}
function switchRepresentationStyles(props) {
	let { color, input } = getTheme_v2(props.theme);
	return css`--switch-bg-color:${color.input.default.enabled.border};--switch-fg-color:${color.input.default.enabled.bg};--switch-box-shadow:none;&:not([hidden]){display:block;}position:relative;width:${rem(input.switch.width)};height:${rem(input.switch.height)};border-radius:${rem(input.switch.height / 2)};pointer-events:none;&:after{content:'';display:block;position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;box-shadow:var(--switch-box-shadow);border-radius:inherit;}input:focus + &&{--switch-box-shadow:${focusRingStyle({ focusRing: input.switch.focusRing })};}input:focus:not(:focus-visible) + &&{--switch-box-shadow:none;}input:checked + &&{--switch-bg-color:${color.input.default.enabled.fg};--switch-fg-color:${color.input.default.enabled.bg};}@media (hover:hover){input:not(:disabled):hover + &&{--switch-bg-color:${color.input.default.hovered.border};--switch-fg-color:${color.input.default.hovered.bg};}input:not(:disabled):checked:hover + &&{--switch-bg-color:${color.input.default.enabled.fg};--switch-fg-color:${color.input.default.enabled.bg};}}input:not([data-read-only]):disabled + &&{--switch-bg-color:${color.input.default.disabled.border};--switch-fg-color:${color.input.default.disabled.bg};}input[data-read-only]:disabled + &&{--switch-bg-color:${color.input.default.readOnly.border};--switch-fg-color:${color.input.default.readOnly.bg};}input:checked[data-read-only]:disabled + &&{--switch-bg-color:${color.input.default.readOnly.fg};--switch-fg-color:${color.input.default.readOnly.bg};}`;
}
function switchTrackStyles(props) {
	let { input } = getTheme_v2(props.theme);
	return css`&:not([hidden]){display:block;}background-color:var(--switch-bg-color);position:absolute;left:0;top:0;width:${rem(input.switch.width)};height:${rem(input.switch.height)};border-radius:${rem(input.switch.height / 2)};`;
}
function switchThumbStyles(props) {
	let { $indeterminate } = props, { input } = getTheme_v2(props.theme), trackWidth = input.switch.width, trackHeight = input.switch.height, trackPadding = input.switch.padding, size = trackHeight - input.switch.padding * 2, checkedOffset = trackWidth - trackPadding * 2 - size, indeterminateOffset = trackWidth / 2 - size / 2 - trackPadding, checked = $indeterminate !== !0 && props.$checked === !0;
	return css`&:not([hidden]){display:block;}position:absolute;left:${rem(trackPadding)};top:${rem(trackPadding)};height:${rem(size)};width:${rem(size)};border-radius:${rem(size / 2)};transition-property:transform;transition-duration:${input.switch.transitionDurationMs}ms;transition-timing-function:${input.switch.transitionTimingFunction};background:var(--switch-fg-color);transform:translate3d(0,0,0);box-shadow:0px 1px 0px 0px rgba(0,0,0,0.05);${checked && css`transform:translate3d(${checkedOffset}px,0,0);`} ${$indeterminate && css`transform:translate3d(${indeterminateOffset}px,0,0);`}`;
}
const StyledSwitch = /* @__PURE__ */ styled.span.withConfig({
	displayName: "StyledSwitch",
	componentId: "sc-wrpexm-0"
})(switchBaseStyles), Input$1 = /* @__PURE__ */ styled.input.withConfig({
	displayName: "Input",
	componentId: "sc-wrpexm-1"
})(switchInputStyles), Representation = /* @__PURE__ */ styled.span.withConfig({
	displayName: "Representation",
	componentId: "sc-wrpexm-2"
})(switchRepresentationStyles), Track = /* @__PURE__ */ styled.span.withConfig({
	displayName: "Track",
	componentId: "sc-wrpexm-3"
})(switchTrackStyles), Thumb = /* @__PURE__ */ styled.span.withConfig({
	displayName: "Thumb",
	componentId: "sc-wrpexm-4"
})(switchThumbStyles);
/**
* The `Switch` component allows the user to toggle a setting on and off.
*
* Extends all properties of an `<input type="checkbox" />` element, except type.
*
* @public
*/
function Switch(props) {
	let $ = c(27), checked, className, disabled, forwardedRef, indeterminate, readOnly, restProps, style;
	$[0] === props ? (checked = $[1], className = $[2], disabled = $[3], forwardedRef = $[4], indeterminate = $[5], readOnly = $[6], restProps = $[7], style = $[8]) : ({checked, className, disabled, indeterminate, readOnly, ref: forwardedRef, style, ...restProps} = props, $[0] = props, $[1] = checked, $[2] = className, $[3] = disabled, $[4] = forwardedRef, $[5] = indeterminate, $[6] = readOnly, $[7] = restProps, $[8] = style);
	let ref = useRef(null), t0;
	$[9] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => ref.current, $[9] = t0) : t0 = $[9], useImperativeHandle(forwardedRef, t0);
	let t1, t2;
	$[10] === indeterminate ? (t1 = $[11], t2 = $[12]) : (t1 = () => {
		ref.current && (ref.current.indeterminate = indeterminate || !1);
	}, t2 = [indeterminate], $[10] = indeterminate, $[11] = t1, $[12] = t2), useEffect(t1, t2);
	let t3 = !disabled && readOnly ? "" : void 0, t4 = indeterminate !== !0 && checked, t5 = disabled || readOnly, t6;
	$[13] !== restProps || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Input$1, {
		"data-read-only": t3,
		...restProps,
		checked: t4,
		disabled: t5,
		type: "checkbox",
		ref
	}), $[13] = restProps, $[14] = t3, $[15] = t4, $[16] = t5, $[17] = t6) : t6 = $[17];
	let t7;
	$[18] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Track, {}), $[18] = t7) : t7 = $[18];
	let t8;
	$[19] !== checked || $[20] !== indeterminate ? (t8 = /* @__PURE__ */ jsxs(Representation, {
		"aria-hidden": !0,
		"data-name": "representation",
		children: [t7, /* @__PURE__ */ jsx(Thumb, {
			$checked: checked,
			$indeterminate: indeterminate
		})]
	}), $[19] = checked, $[20] = indeterminate, $[21] = t8) : t8 = $[21];
	let t9;
	return $[22] !== className || $[23] !== style || $[24] !== t6 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsxs(StyledSwitch, {
		className,
		"data-ui": "Switch",
		style,
		children: [t6, t8]
	}), $[22] = className, $[23] = style, $[24] = t6, $[25] = t8, $[26] = t9) : t9 = $[26], t9;
}
const StyledTextArea = /* @__PURE__ */ styled.span.withConfig({
	displayName: "StyledTextArea",
	componentId: "sc-4tncul-0"
})(textInputRootStyle), InputRoot = styled.span.withConfig({
	displayName: "InputRoot",
	componentId: "sc-4tncul-1"
})`flex:1;min-width:0;display:block;position:relative;`, Input = /* @__PURE__ */ styled.textarea.withConfig({
	displayName: "Input",
	componentId: "sc-4tncul-2"
})(responsiveInputPaddingStyle, textInputBaseStyle, textInputFontSizeStyle), Presentation = /* @__PURE__ */ styled.div.withConfig({
	displayName: "Presentation",
	componentId: "sc-4tncul-3"
})(responsiveRadiusStyle, textInputRepresentationStyle);
/**
* A multiline text input.
*

* @public
*/
function TextArea(props) {
	let $ = c(36), __unstable_disableFocusRing, customValidity, forwardedRef, restProps, t0, t1, t2, t3, t4, weight;
	$[0] === props ? (__unstable_disableFocusRing = $[1], customValidity = $[2], forwardedRef = $[3], restProps = $[4], t0 = $[5], t1 = $[6], t2 = $[7], t3 = $[8], t4 = $[9], weight = $[10]) : ({border: t0, customValidity, disabled: t1, fontSize: t2, padding: t3, radius: t4, ref: forwardedRef, weight, __unstable_disableFocusRing, ...restProps} = props, $[0] = props, $[1] = __unstable_disableFocusRing, $[2] = customValidity, $[3] = forwardedRef, $[4] = restProps, $[5] = t0, $[6] = t1, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = weight);
	let border = t0 === void 0 || t0, disabled = t1 !== void 0 && t1, fontSize = t2 === void 0 ? 2 : t2, padding = t3 === void 0 ? 3 : t3, radius = t4 === void 0 ? 2 : t4, ref = useRef(null), rootTheme = useRootTheme(), t5;
	$[11] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => ref.current, $[11] = t5) : t5 = $[11], useImperativeHandle(forwardedRef, t5), useCustomValidity(ref, customValidity);
	let t6 = rootTheme.scheme, t7 = rootTheme.tone, t8;
	$[12] === fontSize ? t8 = $[13] : (t8 = _getArrayProp(fontSize), $[12] = fontSize, $[13] = t8);
	let t9;
	$[14] === padding ? t9 = $[15] : (t9 = _getArrayProp(padding), $[14] = padding, $[15] = t9);
	let t10 = rootTheme.scheme, t11;
	$[16] === Symbol.for("react.memo_cache_sentinel") ? (t11 = _getArrayProp(0), $[16] = t11) : t11 = $[16];
	let t12;
	$[17] !== disabled || $[18] !== restProps || $[19] !== rootTheme.scheme || $[20] !== rootTheme.tone || $[21] !== t8 || $[22] !== t9 || $[23] !== weight ? (t12 = /* @__PURE__ */ jsx(Input, {
		"data-as": "textarea",
		"data-scheme": t6,
		"data-tone": t7,
		...restProps,
		$fontSize: t8,
		$padding: t9,
		$scheme: t10,
		$space: t11,
		$tone: rootTheme.tone,
		$weight: weight,
		disabled,
		ref
	}), $[17] = disabled, $[18] = restProps, $[19] = rootTheme.scheme, $[20] = rootTheme.tone, $[21] = t8, $[22] = t9, $[23] = weight, $[24] = t12) : t12 = $[24];
	let t13;
	$[25] === radius ? t13 = $[26] : (t13 = _getArrayProp(radius), $[25] = radius, $[26] = t13);
	let t14 = border ? "" : void 0, t15;
	$[27] !== __unstable_disableFocusRing || $[28] !== rootTheme.scheme || $[29] !== rootTheme.tone || $[30] !== t13 || $[31] !== t14 ? (t15 = /* @__PURE__ */ jsx(Presentation, {
		$radius: t13,
		$unstableDisableFocusRing: __unstable_disableFocusRing,
		$scheme: rootTheme.scheme,
		$tone: rootTheme.tone,
		"data-border": t14,
		"data-scheme": rootTheme.scheme,
		"data-tone": rootTheme.tone
	}), $[27] = __unstable_disableFocusRing, $[28] = rootTheme.scheme, $[29] = rootTheme.tone, $[30] = t13, $[31] = t14, $[32] = t15) : t15 = $[32];
	let t16;
	return $[33] !== t12 || $[34] !== t15 ? (t16 = /* @__PURE__ */ jsx(StyledTextArea, {
		"data-ui": "TextArea",
		children: /* @__PURE__ */ jsxs(InputRoot, { children: [t12, t15] })
	}), $[33] = t12, $[34] = t15, $[35] = t16) : t16 = $[35], t16;
}
/**
* @public
*/
function BoundaryElementProvider(props) {
	let $ = c(5), { children, element } = props, t0;
	$[0] === element ? t0 = $[1] : (t0 = {
		version: 0,
		element
	}, $[0] = element, $[1] = t0);
	let value = t0, t1;
	return $[2] !== children || $[3] !== value ? (t1 = /* @__PURE__ */ jsx(BoundaryElementContext.Provider, {
		value,
		children
	}), $[2] = children, $[3] = value, $[4] = t1) : t1 = $[4], t1;
}
/**
* @internal
* @deprecated ConditionalWrapper was removed in @sanity/ui v4. Inline the conditional wrapping logic instead.
*/
function ConditionalWrapper(_props) {
	throw Error("`ConditionalWrapper` was removed in @sanity/ui v4. Inline the conditional wrapping logic instead.");
}
function findMaxBreakpoints(media, width) {
	let ret = [];
	for (let i = 0; i < media.length; i += 1) media[i] > width && ret.push(i);
	return ret;
}
function findMinBreakpoints(media, width) {
	let ret = [];
	for (let i = 0; i < media.length; i += 1) media[i] <= width && ret.push(i);
	return ret;
}
/**
* DO NOT USE IN PRODUCTION.
* @beta
*/
function ElementQuery(props) {
	let $ = c(19), theme = useTheme_v2(), _media, children, forwardedRef, restProps;
	$[0] === props ? (_media = $[1], children = $[2], forwardedRef = $[3], restProps = $[4]) : ({children, media: _media, ref: forwardedRef, ...restProps} = props, $[0] = props, $[1] = _media, $[2] = children, $[3] = forwardedRef, $[4] = restProps);
	let media = _media ?? theme.media, [element, setElement] = useState(null), width = useElementSize(element)?.border.width ?? window.innerWidth, t0;
	if ($[5] !== media || $[6] !== width) {
		let eq = findMaxBreakpoints(media, width);
		t0 = eq.length ? eq.join(" ") : void 0, $[5] = media, $[6] = width, $[7] = t0;
	} else t0 = $[7];
	let max = t0, t1;
	if ($[8] !== media || $[9] !== width) {
		let eq_0 = findMinBreakpoints(media, width);
		t1 = eq_0.length ? eq_0.join(" ") : void 0, $[8] = media, $[9] = width, $[10] = t1;
	} else t1 = $[10];
	let min = t1, t2, t3;
	$[11] === element ? (t2 = $[12], t3 = $[13]) : (t2 = () => element, t3 = [element], $[11] = element, $[12] = t2, $[13] = t3), useImperativeHandle(forwardedRef, t2, t3);
	let t4;
	return $[14] !== children || $[15] !== max || $[16] !== min || $[17] !== restProps ? (t4 = /* @__PURE__ */ jsx("div", {
		"data-ui": "ElementQuery",
		...restProps,
		"data-eq-max": max,
		"data-eq-min": min,
		ref: setElement,
		children
	}), $[14] = children, $[15] = max, $[16] = min, $[17] = restProps, $[18] = t4) : t4 = $[18], t4;
}
/**
* DO NOT USE IN PRODUCTION
* @beta
*/
var ErrorBoundary = class extends Component {
	state = { error: null };
	static getDerivedStateFromError(error) {
		return { error };
	}
	componentDidCatch(error, info) {
		this.props.onCatch({
			error,
			info
		});
	}
	render() {
		let { error } = this.state;
		if (error) {
			let message = typeof error?.message == "string" ? error.message : "Error";
			return /* @__PURE__ */ jsx("pre", {
				"data-ui": "ErrorBoundary",
				children: /* @__PURE__ */ jsx("code", { children: message })
			});
		}
		return this.props.children;
	}
};
/**
* @public
*/
function PortalProvider(props) {
	let $ = c(7), { boundaryElement, children, element, __unstable_elements: elements } = props, fallbackElement = useSyncExternalStore(emptySubscribe, _temp, _temp2), t0 = boundaryElement || null, t1 = element || fallbackElement, t2;
	$[0] !== elements || $[1] !== t0 || $[2] !== t1 ? (t2 = {
		version: 0,
		boundaryElement: t0,
		element: t1,
		elements
	}, $[0] = elements, $[1] = t0, $[2] = t1, $[3] = t2) : t2 = $[3];
	let value = t2, t3;
	return $[4] !== children || $[5] !== value ? (t3 = /* @__PURE__ */ jsx(PortalContext.Provider, {
		value,
		children
	}), $[4] = children, $[5] = value, $[6] = t3) : t3 = $[6], t3;
}
function _temp2() {
	return null;
}
function _temp() {
	return document.body;
}
const emptySubscribe = () => () => {};
var srOnly = "_1omd6w40";
/**
* @public
*/
function SrOnly(props) {
	let $ = c(4), { as: t0, children, ref } = props, Component = t0 === void 0 ? "div" : t0, t1;
	return $[0] !== Component || $[1] !== children || $[2] !== ref ? (t1 = /* @__PURE__ */ jsx(Component, {
		"aria-hidden": !0,
		className: srOnly,
		"data-ui": "SrOnly",
		ref,
		children
	}), $[0] = Component, $[1] = children, $[2] = ref, $[3] = t1) : t1 = $[3], t1;
}
const StyledVirtualList = styled.div.withConfig({
	displayName: "StyledVirtualList",
	componentId: "sc-5jra5s-0"
})`position:relative;`, ItemWrapper = styled.div.withConfig({
	displayName: "ItemWrapper",
	componentId: "sc-5jra5s-1"
})`position:absolute;left:0;right:0;`;
/**
* @beta
*/
function VirtualList(props) {
	let $ = c(45), forwardedRef, getItemKey, onChange, renderItem, restProps, t0, t1, t2;
	$[0] === props ? (forwardedRef = $[1], getItemKey = $[2], onChange = $[3], renderItem = $[4], restProps = $[5], t0 = $[6], t1 = $[7], t2 = $[8]) : ({as: t0, gap: t1, getItemKey, items: t2, onChange, ref: forwardedRef, renderItem, ...restProps} = props, $[0] = props, $[1] = forwardedRef, $[2] = getItemKey, $[3] = onChange, $[4] = renderItem, $[5] = restProps, $[6] = t0, $[7] = t1, $[8] = t2);
	let as = t0 === void 0 ? "div" : t0, gap = t1 === void 0 ? 0 : t1, t3;
	$[9] === t2 ? t3 = $[10] : (t3 = t2 === void 0 ? [] : t2, $[9] = t2, $[10] = t3);
	let items = t3, { space } = useTheme_v2(), ref = useRef(null), wrapperRef = useRef(null), [scrollTop, setScrollTop] = useState(0), [scrollHeight, setScrollHeight] = useState(0), [itemHeight, setItemHeight] = useState(-1), t4;
	$[11] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => ref.current, $[11] = t4) : t4 = $[11], useImperativeHandle(forwardedRef, t4);
	let t5;
	$[12] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
		if (!wrapperRef.current) return;
		let firstElement = wrapperRef.current.firstChild;
		firstElement instanceof HTMLElement && setItemHeight(firstElement.offsetHeight);
	}, $[12] = t5) : t5 = $[12];
	let t6;
	$[13] === renderItem ? t6 = $[14] : (t6 = [renderItem], $[13] = renderItem, $[14] = t6), useEffect(t5, t6);
	let t7, t8;
	$[15] === Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
		if (!ref.current) return;
		let scrollEl = findScrollable(ref.current.parentNode);
		if (scrollEl) {
			if (!(scrollEl instanceof HTMLElement)) return;
			let handleScroll = () => {
				setScrollTop(scrollEl.scrollTop);
			};
			scrollEl.addEventListener("scroll", handleScroll, { passive: !0 });
			let ro = new ResizeObserver((entries) => {
				setScrollHeight(entries[0].contentRect.height);
			});
			return ro.observe(scrollEl), handleScroll(), () => {
				scrollEl.removeEventListener("scroll", handleScroll), ro.unobserve(scrollEl), ro.disconnect();
			};
		}
		let handleScroll_0 = () => {
			setScrollTop(window.scrollY);
		}, handleResize = () => {
			setScrollHeight(window.innerHeight);
		};
		return window.addEventListener("scroll", handleScroll_0, { passive: !0 }), window.addEventListener("resize", handleResize), setScrollHeight(window.innerHeight), handleScroll_0(), () => {
			window.removeEventListener("scroll", handleScroll_0), window.removeEventListener("resize", handleResize);
		};
	}, t8 = [], $[15] = t7, $[16] = t8) : (t7 = $[15], t8 = $[16]), useEffect(t7, t8);
	let len = items.length, height = itemHeight ? len * (itemHeight + space[gap]) - space[gap] : 0, fromIndex = height ? Math.max(Math.floor(scrollTop / height * len) - 2, 0) : 0, toIndex = height ? Math.ceil((scrollTop + scrollHeight) / height * len) + 1 : 0, t10, t9;
	$[17] !== fromIndex || $[18] !== gap || $[19] !== itemHeight || $[20] !== onChange || $[21] !== scrollHeight || $[22] !== scrollTop || $[23] !== space || $[24] !== toIndex ? (t9 = () => {
		onChange && onChange({
			fromIndex,
			gap: space[gap],
			itemHeight,
			scrollHeight,
			scrollTop,
			toIndex
		});
	}, t10 = [
		fromIndex,
		gap,
		itemHeight,
		onChange,
		scrollHeight,
		scrollTop,
		space,
		toIndex
	], $[17] = fromIndex, $[18] = gap, $[19] = itemHeight, $[20] = onChange, $[21] = scrollHeight, $[22] = scrollTop, $[23] = space, $[24] = toIndex, $[25] = t10, $[26] = t9) : (t10 = $[25], t9 = $[26]), useEffect(t9, t10);
	let t11;
	$[27] !== fromIndex || $[28] !== gap || $[29] !== getItemKey || $[30] !== itemHeight || $[31] !== items || $[32] !== renderItem || $[33] !== space || $[34] !== toIndex ? (t11 = {
		fromIndex,
		gap,
		itemHeight,
		space,
		toIndex,
		getItemKey,
		items,
		renderItem
	}, $[27] = fromIndex, $[28] = gap, $[29] = getItemKey, $[30] = itemHeight, $[31] = items, $[32] = renderItem, $[33] = space, $[34] = toIndex, $[35] = t11) : t11 = $[35];
	let children = useChildren(t11), t12 = as, t13;
	$[36] === height ? t13 = $[37] : (t13 = { height }, $[36] = height, $[37] = t13);
	let t14;
	$[38] !== children || $[39] !== t13 ? (t14 = /* @__PURE__ */ jsx("div", {
		ref: wrapperRef,
		style: t13,
		children
	}), $[38] = children, $[39] = t13, $[40] = t14) : t14 = $[40];
	let t15;
	return $[41] !== restProps || $[42] !== t12 || $[43] !== t14 ? (t15 = /* @__PURE__ */ jsx(StyledVirtualList, {
		as: t12,
		"data-ui": "VirtualList",
		...restProps,
		ref,
		children: t14
	}), $[41] = restProps, $[42] = t12, $[43] = t14, $[44] = t15) : t15 = $[44], t15;
}
function useChildren(t0) {
	let $ = c(21), { fromIndex, gap, getItemKey, itemHeight, items, renderItem, space, toIndex } = t0;
	if (!renderItem || items.length === 0) return null;
	if (itemHeight === -1) {
		let t1;
		$[0] !== items[0] || $[1] !== renderItem ? (t1 = renderItem(items[0]), $[0] = items[0], $[1] = renderItem, $[2] = t1) : t1 = $[2];
		let t2;
		return $[3] === t1 ? t2 = $[4] : (t2 = [/* @__PURE__ */ jsx(ItemWrapper, { children: t1 }, 0)], $[3] = t1, $[4] = t2), t2;
	}
	let t1;
	if ($[5] !== fromIndex || $[6] !== gap || $[7] !== getItemKey || $[8] !== itemHeight || $[9] !== items || $[10] !== renderItem || $[11] !== space || $[12] !== toIndex) {
		let t2;
		$[14] !== fromIndex || $[15] !== gap || $[16] !== getItemKey || $[17] !== itemHeight || $[18] !== renderItem || $[19] !== space ? (t2 = (item, _itemIndex) => {
			let itemIndex = fromIndex + _itemIndex, node = renderItem(item), key = getItemKey ? getItemKey(item, itemIndex) : itemIndex;
			return /* @__PURE__ */ jsx(ItemWrapper, {
				style: { top: itemIndex * (itemHeight + space[gap]) },
				children: node
			}, key);
		}, $[14] = fromIndex, $[15] = gap, $[16] = getItemKey, $[17] = itemHeight, $[18] = renderItem, $[19] = space, $[20] = t2) : t2 = $[20], t1 = items.slice(fromIndex, toIndex).map(t2), $[5] = fromIndex, $[6] = gap, $[7] = getItemKey, $[8] = itemHeight, $[9] = items, $[10] = renderItem, $[11] = space, $[12] = toIndex, $[13] = t1;
	} else t1 = $[13];
	return t1;
}
function findScrollable(parentNode) {
	let _scrollEl = parentNode;
	for (; _scrollEl && !_isScrollable(_scrollEl);) _scrollEl = _scrollEl.parentNode;
	return _scrollEl;
}
export { Arrow, Avatar, AvatarCounter, AvatarStack, Badge, BoundaryElementProvider, Box, Button, Card, Checkbox, CodeSkeleton, ConditionalWrapper, Container, Dialog, DialogContext, DialogProvider, ElementQuery, ErrorBoundary, Flex, Grid, Heading, HeadingSkeleton, Hotkeys, Inline, KBD, Label, LabelSkeleton, Layer, LayerProvider, Portal, PortalProvider, Radio, Select, Skeleton, Spinner, SrOnly, Stack, Switch, Tab, TabList, TabPanel, Text, TextArea, TextInput, TextSkeleton, ThemeColorProvider, ThemeProvider, Tree, TreeItem, VirtualList, _elementSizeObserver, _fillCSSObject, _getArrayProp, _getResponsiveSpace, _hasFocus, _isEnterToClickElement, _isScrollable, _raf, _raf2, _responsive, attemptFocus, containsOrEqualsElement, createColorTheme, focusFirstDescendant, focusLastDescendant, hexToRgb, hslToRgb, isFocusable, isHTMLAnchorElement, isHTMLButtonElement, isHTMLElement, isHTMLInputElement, isHTMLSelectElement, isHTMLTextAreaElement, multiply, parseColor, rem, responsiveCodeFontStyle, responsiveHeadingFont, responsiveLabelFont, responsiveTextAlignStyle, responsiveTextFont, rgbToHex, rgbToHsl, rgba, screen, studioTheme, useArrayProp, useBoundaryElement, useClickOutside, useClickOutsideEvent, useCustomValidity, useDialog, useElementRect, useElementSize, useForwardedRef, useGlobalKeyDown, useLayer, useMatchMedia, useMediaIndex, usePortal, usePrefersDark, usePrefersReducedMotion, useRootTheme, useTheme, useTheme_v2, useTree };

//# sourceMappingURL=index.js.map